(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) : typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) : (global = global || self, factory(global.schemaUI = {}, global.React));
})(this, function (exports, React) {
  'use strict';

  var React__default = 'default' in React ? React['default'] : React;

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var BUTTON = 'button';
  var INVERSE_BUTTON = 'inverseButton';
  var BUTTON_DISABLED = "".concat(BUTTON, "Disabled");
  var BUTTON_SIZES = {
    BIG: 'BIG',
    MEDIUM: 'MEDIUM',
    SMALL: 'SMALL'
  };

  var _light, _dark;

  var colors = {
    white: '#FFF',
    black: '#000',
    darkGrey: '#1d1d20',
    lightGrey: '#71737e',
    veryLightPink: '#f0efef',
    coolGray: '#a6a7aa',
    mediumGray: '#2F2F36',
    red: '#f21e29',
    yellow: '#be8f00'
  };
  var light = (_light = {
    switch: {
      backgroundActive: colors.coolGray,
      background: colors.veryLightPink,
      circle: colors.black
    }
  }, _defineProperty(_light, BUTTON, {
    background: colors.veryLightPink,
    text: colors.black
  }), _defineProperty(_light, INVERSE_BUTTON, {
    background: colors.black,
    text: colors.white
  }), _defineProperty(_light, BUTTON_DISABLED, {
    background: colors.veryLightPink,
    text: colors.coolGray
  }), _defineProperty(_light, "card", {
    label: colors.coolGray,
    border: colors.black,
    background: colors.veryLightPink,
    text: colors.black
  }), _defineProperty(_light, "providerContainer", {
    minHeight: '100vh'
  }), _defineProperty(_light, "dataGrid", {
    background: colors.veryLightPink,
    text: colors.coolGray
  }), _defineProperty(_light, "checkbox", {
    border: colors.mediumGray,
    text: colors.black
  }), _defineProperty(_light, "input", {
    text: colors.black
  }), _defineProperty(_light, "label", {
    text: colors.coolGray,
    border: colors.veryLightPink
  }), _defineProperty(_light, "breadcrumbs", {
    link: colors.darkGrey,
    separator: colors.darkGrey,
    border: colors.darkGrey
  }), _defineProperty(_light, "linkItem", {
    link: colors.darkGrey,
    hover: colors.black
  }), _defineProperty(_light, "link", {
    text: colors.darkGrey,
    hover: colors.black
  }), _defineProperty(_light, "textArea", {
    text: colors.black
  }), _defineProperty(_light, "textField", {
    label: colors.coolGray,
    error: colors.red
  }), _defineProperty(_light, "header", {
    text: colors.darkGrey,
    border: colors.veryLightPink
  }), _defineProperty(_light, "menu", {
    background: colors.white,
    text: colors.black
  }), _defineProperty(_light, "stepper", {
    background: colors.veryLightPink,
    active: colors.darkGrey
  }), _defineProperty(_light, "icon", {
    background: colors.veryLightPink,
    fill: colors.darkGrey,
    fillInverse: colors.white
  }), _defineProperty(_light, "radioButton", {
    text: colors.darkGrey,
    border: colors.darkGrey,
    active: {
      background: colors.darkGrey,
      fill: colors.white
    },
    unActive: {
      background: colors.veryLightPink,
      fill: colors.white
    }
  }), _defineProperty(_light, "table", {
    border: {
      body: colors.veryLightPink,
      header: colors.white
    },
    background: {
      body: colors.white,
      header: colors.veryLightPink
    },
    text: {
      body: colors.black,
      header: colors.coolGray
    }
  }), _defineProperty(_light, "tab", {
    normal: colors.veryLightPink,
    active: colors.black,
    hover: colors.black
  }), _defineProperty(_light, "select", {
    background: colors.veryLightPink,
    border: colors.white
  }), _defineProperty(_light, "accordion", {
    background: colors.white,
    border: colors.black
  }), _defineProperty(_light, "slider", {
    thumb: colors.black,
    background: colors.veryLightPink,
    selectedBackground: colors.lightGrey
  }), _defineProperty(_light, "background", colors.white), _defineProperty(_light, "hiddenBackground", 'rgba(255, 255, 255, 0)'), _defineProperty(_light, "border", colors.veryLightPink), _defineProperty(_light, "text", colors.darkGrey), _defineProperty(_light, "secondaryText", colors.coolGray), _defineProperty(_light, "error", colors.red), _defineProperty(_light, "warning", colors.yellow), _defineProperty(_light, "colors", colors), _light);
  var dark = (_dark = {
    switch: {
      backgroundActive: colors.lightGrey,
      background: colors.mediumGray,
      circle: colors.white
    }
  }, _defineProperty(_dark, BUTTON, {
    background: colors.darkGrey,
    text: colors.white
  }), _defineProperty(_dark, INVERSE_BUTTON, {
    background: colors.white,
    text: colors.black
  }), _defineProperty(_dark, BUTTON_DISABLED, {
    background: colors.darkGrey,
    text: colors.lightGrey
  }), _defineProperty(_dark, "card", {
    label: colors.lightGrey,
    border: colors.white,
    background: colors.darkGrey,
    text: colors.white
  }), _defineProperty(_dark, "providerContainer", {
    minHeight: '100vh'
  }), _defineProperty(_dark, "dataGrid", {
    background: colors.black,
    text: colors.lightGrey
  }), _defineProperty(_dark, "checkbox", {
    border: colors.mediumGray,
    text: colors.white
  }), _defineProperty(_dark, "input", {
    text: colors.white
  }), _defineProperty(_dark, "breadcrumbs", {
    link: colors.coolGray,
    separator: colors.coolGray,
    border: colors.coolGray
  }), _defineProperty(_dark, "linkItem", {
    link: colors.coolGray,
    hover: colors.white
  }), _defineProperty(_dark, "link", {
    text: colors.coolGray,
    hover: colors.white
  }), _defineProperty(_dark, "label", {
    text: colors.lightGrey,
    border: colors.mediumGray
  }), _defineProperty(_dark, "textArea", {
    text: colors.white,
    background: colors.black
  }), _defineProperty(_dark, "textField", {
    label: colors.lightGrey,
    error: colors.red
  }), _defineProperty(_dark, "header", {
    text: colors.white,
    border: colors.mediumGray
  }), _defineProperty(_dark, "menu", {
    background: colors.black,
    text: colors.white
  }), _defineProperty(_dark, "stepper", {
    background: colors.darkGrey,
    active: colors.white
  }), _defineProperty(_dark, "icon", {
    background: colors.darkGrey,
    fill: colors.white,
    fillInverse: colors.black
  }), _defineProperty(_dark, "radioButton", {
    text: colors.white,
    border: colors.white,
    active: {
      background: colors.white,
      fill: colors.darkGrey
    },
    unActive: {
      background: colors.darkGrey,
      fill: colors.white,
      dot: colors.white
    }
  }), _defineProperty(_dark, "table", {
    border: {
      body: colors.darkGrey,
      header: colors.black
    },
    background: {
      body: colors.black,
      header: colors.darkGrey
    },
    text: {
      body: colors.white,
      header: colors.lightGrey
    }
  }), _defineProperty(_dark, "tab", {
    normal: colors.mediumGray,
    active: colors.white,
    hover: colors.white
  }), _defineProperty(_dark, "select", {
    background: colors.darkGrey,
    border: colors.mediumGray
  }), _defineProperty(_dark, "accordion", {
    background: colors.black,
    border: colors.white
  }), _defineProperty(_dark, "slider", {
    thumb: colors.white,
    background: colors.darkGrey,
    selectedBackground: colors.lightGrey
  }), _defineProperty(_dark, "background", colors.black), _defineProperty(_dark, "hiddenBackground", 'rgba(0, 0, 0, 0)'), _defineProperty(_dark, "text", colors.white), _defineProperty(_dark, "border", colors.mediumGray), _defineProperty(_dark, "secondaryText", colors.lightGrey), _defineProperty(_dark, "error", colors.red), _defineProperty(_dark, "warning", colors.yellow), _defineProperty(_dark, "colors", colors), _dark);
  var INTER_FONT = 'Inter, "Helvetica Neue", Helvetica, Arial, sans-serif';
  var MONOSPACE_FONT = 'Hack, monospace';
  var typography = {
    h1: {
      fontFamily: INTER_FONT,
      fontWeight: 600,
      fontSize: '24px'
    },
    h2: {
      fontFamily: INTER_FONT,
      fontWeight: 100,
      fontSize: '24px'
    },
    h3: {
      fontFamily: INTER_FONT,
      fontWeight: 600,
      fontSize: '18px'
    },
    p: {
      fontFamily: INTER_FONT,
      fontWeight: 200,
      fontSize: '18px'
    },
    pre: {
      fontFamily: MONOSPACE_FONT,
      fontSize: '18px'
    },
    span: {
      fontFamily: INTER_FONT,
      fontSize: '14px'
    }
  };
  light.typography = typography;
  dark.typography = typography;
  var defaultTheme = dark;
  var Theme = {
    light: light,
    dark: dark,
    colors: colors
  };

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    return function () {
      var Super = _getPrototypeOf(Derived),
          result;

      if (_isNativeReflectConstruct()) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  var getStyles = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      headerStyles: {
        color: theme.card.label,
        marginBottom: 14
      },
      footerStyles: {
        color: theme.label.text,
        marginTop: 10,
        marginBottom: 4
      },
      upperStyles: {
        width: '100%',
        height: '100%'
      },
      containerStyles: {
        position: 'relative',
        fontSize: '12px',
        fontFamily: theme.typography.span.fontFamily,
        borderTop: "2px solid ".concat(theme.card.border),
        backgroundColor: theme.card.background,
        color: theme.text,
        padding: '12px 14px 14px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }
    };
  };

  var ThemeContext = React__default.createContext({});

  var withStyles = function withStyles(Component) {
    return function (props) {
      return (
        /*#__PURE__*/
        React__default.createElement(ThemeContext.Consumer, null, function (_ref) {
          var theme = _ref.theme;
          return (
            /*#__PURE__*/
            React__default.createElement(Component, Object.assign({
              theme: theme
            }, props))
          );
        })
      );
    };
  };

  var a = ["accesskey", "charset", "coords", "download", "href", "hreflang", "name", "ping", "referrerpolicy", "rel", "rev", "shape", "tabindex", "target", "type"];
  var abbr = ["title"];
  var applet = ["align", "alt", "archive", "code", "codebase", "height", "hspace", "name", "object", "vspace", "width"];
  var area = ["accesskey", "alt", "coords", "download", "href", "hreflang", "nohref", "ping", "referrerpolicy", "rel", "shape", "tabindex", "target", "type"];
  var audio = ["autoplay", "controls", "crossorigin", "loop", "muted", "preload", "src"];
  var base = ["href", "target"];
  var basefont = ["color", "face", "size"];
  var bdo = ["dir"];
  var blockquote = ["cite"];
  var body = ["alink", "background", "bgcolor", "link", "text", "vlink"];
  var br = ["clear"];
  var button = ["accesskey", "autofocus", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "name", "tabindex", "type", "value"];
  var canvas = ["height", "width"];
  var caption = ["align"];
  var col = ["align", "char", "charoff", "span", "valign", "width"];
  var colgroup = ["align", "char", "charoff", "span", "valign", "width"];
  var data = ["value"];
  var del = ["cite", "datetime"];
  var details = ["open"];
  var dfn = ["title"];
  var dialog = ["open"];
  var dir = ["compact"];
  var div = ["align"];
  var dl = ["compact"];
  var embed = ["height", "src", "type", "width"];
  var fieldset = ["disabled", "form", "name"];
  var font = ["color", "face", "size"];
  var form = ["accept", "accept-charset", "action", "autocomplete", "enctype", "method", "name", "novalidate", "target"];
  var frame = ["frameborder", "longdesc", "marginheight", "marginwidth", "name", "noresize", "scrolling", "src"];
  var frameset = ["cols", "rows"];
  var h1 = ["align"];
  var h2 = ["align"];
  var h3 = ["align"];
  var h4 = ["align"];
  var h5 = ["align"];
  var h6 = ["align"];
  var head = ["profile"];
  var hr = ["align", "noshade", "size", "width"];
  var html = ["manifest", "version"];
  var iframe = ["align", "allow", "allowfullscreen", "allowpaymentrequest", "allowusermedia", "frameborder", "height", "longdesc", "marginheight", "marginwidth", "name", "referrerpolicy", "sandbox", "scrolling", "src", "srcdoc", "width"];
  var img = ["align", "alt", "border", "crossorigin", "decoding", "height", "hspace", "ismap", "longdesc", "name", "referrerpolicy", "sizes", "src", "srcset", "usemap", "vspace", "width"];
  var input = ["accept", "accesskey", "align", "alt", "autocomplete", "autofocus", "checked", "dirname", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "height", "ismap", "list", "max", "maxlength", "min", "minlength", "multiple", "name", "pattern", "placeholder", "readonly", "required", "size", "src", "step", "tabindex", "title", "type", "usemap", "value", "width"];
  var ins = ["cite", "datetime"];
  var isindex = ["prompt"];
  var label = ["accesskey", "for", "form"];
  var legend = ["accesskey", "align"];
  var li = ["type", "value"];
  var link = ["as", "charset", "color", "crossorigin", "href", "hreflang", "imagesizes", "imagesrcset", "integrity", "media", "nonce", "referrerpolicy", "rel", "rev", "sizes", "target", "title", "type"];
  var map = ["name"];
  var menu = ["compact"];
  var meta = ["charset", "content", "http-equiv", "name", "scheme"];
  var meter = ["high", "low", "max", "min", "optimum", "value"];
  var object = ["align", "archive", "border", "classid", "codebase", "codetype", "data", "declare", "form", "height", "hspace", "name", "standby", "tabindex", "type", "typemustmatch", "usemap", "vspace", "width"];
  var ol = ["compact", "reversed", "start", "type"];
  var optgroup = ["disabled", "label"];
  var option = ["disabled", "label", "selected", "value"];
  var output = ["for", "form", "name"];
  var p = ["align"];
  var param = ["name", "type", "value", "valuetype"];
  var pre = ["width"];
  var progress = ["max", "value"];
  var q = ["cite"];
  var script = ["async", "charset", "crossorigin", "defer", "integrity", "language", "nomodule", "nonce", "referrerpolicy", "src", "type"];
  var select = ["autocomplete", "autofocus", "disabled", "form", "multiple", "name", "required", "size", "tabindex"];
  var slot = ["name"];
  var source = ["media", "sizes", "src", "srcset", "type"];
  var style = ["media", "nonce", "title", "type"];
  var table = ["align", "bgcolor", "border", "cellpadding", "cellspacing", "frame", "rules", "summary", "width"];
  var tbody = ["align", "char", "charoff", "valign"];
  var td = ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"];
  var textarea = ["accesskey", "autocomplete", "autofocus", "cols", "dirname", "disabled", "form", "maxlength", "minlength", "name", "placeholder", "readonly", "required", "rows", "tabindex", "wrap"];
  var tfoot = ["align", "char", "charoff", "valign"];
  var th = ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"];
  var thead = ["align", "char", "charoff", "valign"];
  var time = ["datetime"];
  var tr = ["align", "bgcolor", "char", "charoff", "valign"];
  var track = ["default", "kind", "label", "src", "srclang"];
  var ul = ["compact", "type"];
  var video = ["autoplay", "controls", "crossorigin", "height", "loop", "muted", "playsinline", "poster", "preload", "src", "width"];
  var elementAttributes = {
    "*": ["accesskey", "autocapitalize", "autofocus", "class", "contenteditable", "dir", "draggable", "enterkeyhint", "hidden", "id", "inputmode", "is", "itemid", "itemprop", "itemref", "itemscope", "itemtype", "lang", "nonce", "slot", "spellcheck", "style", "tabindex", "title", "translate"],
    a: a,
    abbr: abbr,
    applet: applet,
    area: area,
    audio: audio,
    base: base,
    basefont: basefont,
    bdo: bdo,
    blockquote: blockquote,
    body: body,
    br: br,
    button: button,
    canvas: canvas,
    caption: caption,
    col: col,
    colgroup: colgroup,
    data: data,
    del: del,
    details: details,
    dfn: dfn,
    dialog: dialog,
    dir: dir,
    div: div,
    dl: dl,
    embed: embed,
    fieldset: fieldset,
    font: font,
    form: form,
    frame: frame,
    frameset: frameset,
    h1: h1,
    h2: h2,
    h3: h3,
    h4: h4,
    h5: h5,
    h6: h6,
    head: head,
    hr: hr,
    html: html,
    iframe: iframe,
    img: img,
    input: input,
    ins: ins,
    isindex: isindex,
    label: label,
    legend: legend,
    li: li,
    link: link,
    map: map,
    menu: menu,
    meta: meta,
    meter: meter,
    object: object,
    ol: ol,
    optgroup: optgroup,
    option: option,
    output: output,
    p: p,
    param: param,
    pre: pre,
    progress: progress,
    q: q,
    script: script,
    select: select,
    slot: slot,
    source: source,
    style: style,
    table: table,
    tbody: tbody,
    td: td,
    textarea: textarea,
    tfoot: tfoot,
    th: th,
    thead: thead,
    time: time,
    tr: tr,
    track: track,
    ul: ul,
    video: video
  };
  var additionalAllowedAttributes = ['className', 'onClick', 'onChange', 'onBlur', 'onFocus', 'defaultValue', 'onKeyDown', 'autoFocus'];

  var filterAllowedAttributes = function filterAllowedAttributes(element, props) {
    var attributes = elementAttributes['*'].concat(elementAttributes[element] || []).concat(additionalAllowedAttributes);
    return Object.keys(props).filter(function (key) {
      return attributes.includes(key);
    }).reduce(function (obj, key) {
      return _objectSpread2(_defineProperty({}, key, props[key]), obj);
    }, {});
  };

  var CardComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CardComponent, _PureComponent);

    var _super = _createSuper(CardComponent);

    function CardComponent() {
      var _this;

      _classCallCheck(this, CardComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.renderHeader = function (component, headerStyles) {
        return component ?
        /*#__PURE__*/
        React__default.createElement("div", {
          style: headerStyles
        }, component) : null;
      };

      _this.renderFooter = function (component, footerStyles) {
        return component ?
        /*#__PURE__*/
        React__default.createElement("div", {
          style: footerStyles
        }, component) : null;
      };

      return _this;
    }

    _createClass(CardComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            headerComponent = _this$props.headerComponent,
            footerComponent = _this$props.footerComponent,
            children = _this$props.children,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "headerComponent", "footerComponent", "children", "theme"]);

        var _getStyles = getStyles(theme),
            containerStyles = _getStyles.containerStyles,
            headerStyles = _getStyles.headerStyles,
            footerStyles = _getStyles.footerStyles,
            upperStyles = _getStyles.upperStyles;

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        var filteredProps = filterAllowedAttributes('div', restProps);
        return (
          /*#__PURE__*/
          React__default.createElement("div", Object.assign({
            style: styles
          }, filteredProps),
          /*#__PURE__*/
          React__default.createElement("div", {
            style: upperStyles
          }, this.renderHeader(headerComponent, headerStyles), children), this.renderFooter(footerComponent, footerStyles))
        );
      }
    }]);

    return CardComponent;
  }(React.PureComponent);

  var Card = withStyles(CardComponent);

  function _isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
  }
  /**
   * Optimized internal one-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry1(fn) {
    return function f1(a) {
      if (arguments.length === 0 || _isPlaceholder(a)) {
        return f1;
      } else {
        return fn.apply(this, arguments);
      }
    };
  }
  /**
   * Optimized internal two-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry2(fn) {
    return function f2(a, b) {
      switch (arguments.length) {
        case 0:
          return f2;

        case 1:
          return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
            return fn(a, _b);
          });

        default:
          return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
            return fn(_a, b);
          }) : _isPlaceholder(b) ? _curry1(function (_b) {
            return fn(a, _b);
          }) : fn(a, b);
      }
    };
  }
  /**
   * Private `concat` function to merge two array-like objects.
   *
   * @private
   * @param {Array|Arguments} [set1=[]] An array-like object.
   * @param {Array|Arguments} [set2=[]] An array-like object.
   * @return {Array} A new, merged array.
   * @example
   *
   *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
   */


  function _concat(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;

    while (idx < len1) {
      result[result.length] = set1[idx];
      idx += 1;
    }

    idx = 0;

    while (idx < len2) {
      result[result.length] = set2[idx];
      idx += 1;
    }

    return result;
  }

  function _arity(n, fn) {
    /* eslint-disable no-unused-vars */
    switch (n) {
      case 0:
        return function () {
          return fn.apply(this, arguments);
        };

      case 1:
        return function (a0) {
          return fn.apply(this, arguments);
        };

      case 2:
        return function (a0, a1) {
          return fn.apply(this, arguments);
        };

      case 3:
        return function (a0, a1, a2) {
          return fn.apply(this, arguments);
        };

      case 4:
        return function (a0, a1, a2, a3) {
          return fn.apply(this, arguments);
        };

      case 5:
        return function (a0, a1, a2, a3, a4) {
          return fn.apply(this, arguments);
        };

      case 6:
        return function (a0, a1, a2, a3, a4, a5) {
          return fn.apply(this, arguments);
        };

      case 7:
        return function (a0, a1, a2, a3, a4, a5, a6) {
          return fn.apply(this, arguments);
        };

      case 8:
        return function (a0, a1, a2, a3, a4, a5, a6, a7) {
          return fn.apply(this, arguments);
        };

      case 9:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
          return fn.apply(this, arguments);
        };

      case 10:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
          return fn.apply(this, arguments);
        };

      default:
        throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
  }
  /**
   * Internal curryN function.
   *
   * @private
   * @category Function
   * @param {Number} length The arity of the curried function.
   * @param {Array} received An array of arguments received thus far.
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curryN(length, received, fn) {
    return function () {
      var combined = [];
      var argsIdx = 0;
      var left = length;
      var combinedIdx = 0;

      while (combinedIdx < received.length || argsIdx < arguments.length) {
        var result;

        if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
          result = received[combinedIdx];
        } else {
          result = arguments[argsIdx];
          argsIdx += 1;
        }

        combined[combinedIdx] = result;

        if (!_isPlaceholder(result)) {
          left -= 1;
        }

        combinedIdx += 1;
      }

      return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
    };
  }
  /**
   * Returns a curried equivalent of the provided function, with the specified
   * arity. The curried function has two unusual capabilities. First, its
   * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
   * following are equivalent:
   *
   *   - `g(1)(2)(3)`
   *   - `g(1)(2, 3)`
   *   - `g(1, 2)(3)`
   *   - `g(1, 2, 3)`
   *
   * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
   * "gaps", allowing partial application of any combination of arguments,
   * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
   * the following are equivalent:
   *
   *   - `g(1, 2, 3)`
   *   - `g(_, 2, 3)(1)`
   *   - `g(_, _, 3)(1)(2)`
   *   - `g(_, _, 3)(1, 2)`
   *   - `g(_, 2)(1)(3)`
   *   - `g(_, 2)(1, 3)`
   *   - `g(_, 2)(_, 3)(1)`
   *
   * @func
   * @memberOf R
   * @since v0.5.0
   * @category Function
   * @sig Number -> (* -> a) -> (* -> a)
   * @param {Number} length The arity for the returned function.
   * @param {Function} fn The function to curry.
   * @return {Function} A new, curried function.
   * @see R.curry
   * @example
   *
   *      const sumArgs = (...args) => R.sum(args);
   *
   *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
   *      const f = curriedAddFourNumbers(1, 2);
   *      const g = f(3);
   *      g(4); //=> 10
   */


  var curryN =
  /*#__PURE__*/
  _curry2(function curryN(length, fn) {
    if (length === 1) {
      return _curry1(fn);
    }

    return _arity(length, _curryN(length, [], fn));
  });
  /**
   * Optimized internal three-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry3(fn) {
    return function f3(a, b, c) {
      switch (arguments.length) {
        case 0:
          return f3;

        case 1:
          return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          });

        case 2:
          return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
            return fn(_a, b, _c);
          }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          }) : _curry1(function (_c) {
            return fn(a, b, _c);
          });

        default:
          return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
            return fn(_a, _b, c);
          }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
            return fn(_a, b, _c);
          }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          }) : _isPlaceholder(a) ? _curry1(function (_a) {
            return fn(_a, b, c);
          }) : _isPlaceholder(b) ? _curry1(function (_b) {
            return fn(a, _b, c);
          }) : _isPlaceholder(c) ? _curry1(function (_c) {
            return fn(a, b, _c);
          }) : fn(a, b, c);
      }
    };
  }
  /**
   * Tests whether or not an object is an array.
   *
   * @private
   * @param {*} val The object to test.
   * @return {Boolean} `true` if `val` is an array, `false` otherwise.
   * @example
   *
   *      _isArray([]); //=> true
   *      _isArray(null); //=> false
   *      _isArray({}); //=> false
   */


  var _isArray = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
  };

  function _isTransformer(obj) {
    return obj != null && typeof obj['@@transducer/step'] === 'function';
  }
  /**
   * Returns a function that dispatches with different strategies based on the
   * object in list position (last argument). If it is an array, executes [fn].
   * Otherwise, if it has a function with one of the given method names, it will
   * execute that function (functor case). Otherwise, if it is a transformer,
   * uses transducer [xf] to return a new transformer (transducer case).
   * Otherwise, it will default to executing [fn].
   *
   * @private
   * @param {Array} methodNames properties to check for a custom implementation
   * @param {Function} xf transducer to initialize if object is transformer
   * @param {Function} fn default ramda implementation
   * @return {Function} A function that dispatches on object in list position
   */


  function _dispatchable(methodNames, xf, fn) {
    return function () {
      if (arguments.length === 0) {
        return fn();
      }

      var args = Array.prototype.slice.call(arguments, 0);
      var obj = args.pop();

      if (!_isArray(obj)) {
        var idx = 0;

        while (idx < methodNames.length) {
          if (typeof obj[methodNames[idx]] === 'function') {
            return obj[methodNames[idx]].apply(obj, args);
          }

          idx += 1;
        }

        if (_isTransformer(obj)) {
          var transducer = xf.apply(null, args);
          return transducer(obj);
        }
      }

      return fn.apply(this, arguments);
    };
  }

  function _reduced(x) {
    return x && x['@@transducer/reduced'] ? x : {
      '@@transducer/value': x,
      '@@transducer/reduced': true
    };
  }

  var _xfBase = {
    init: function init() {
      return this.xf['@@transducer/init']();
    },
    result: function result(_result) {
      return this.xf['@@transducer/result'](_result);
    }
  };

  function _map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);

    while (idx < len) {
      result[idx] = fn(functor[idx]);
      idx += 1;
    }

    return result;
  }

  function _isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
  }
  /**
   * Tests whether or not an object is similar to an array.
   *
   * @private
   * @category Type
   * @category List
   * @sig * -> Boolean
   * @param {*} x The object to test.
   * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
   * @example
   *
   *      _isArrayLike([]); //=> true
   *      _isArrayLike(true); //=> false
   *      _isArrayLike({}); //=> false
   *      _isArrayLike({length: 10}); //=> false
   *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
   */


  var _isArrayLike =
  /*#__PURE__*/
  _curry1(function isArrayLike(x) {
    if (_isArray(x)) {
      return true;
    }

    if (!x) {
      return false;
    }

    if (typeof x !== 'object') {
      return false;
    }

    if (_isString(x)) {
      return false;
    }

    if (x.nodeType === 1) {
      return !!x.length;
    }

    if (x.length === 0) {
      return true;
    }

    if (x.length > 0) {
      return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    }

    return false;
  });

  var XWrap =
  /*#__PURE__*/
  function () {
    function XWrap(fn) {
      this.f = fn;
    }

    XWrap.prototype['@@transducer/init'] = function () {
      throw new Error('init not implemented on XWrap');
    };

    XWrap.prototype['@@transducer/result'] = function (acc) {
      return acc;
    };

    XWrap.prototype['@@transducer/step'] = function (acc, x) {
      return this.f(acc, x);
    };

    return XWrap;
  }();

  function _xwrap(fn) {
    return new XWrap(fn);
  }
  /**
   * Creates a function that is bound to a context.
   * Note: `R.bind` does not provide the additional argument-binding capabilities of
   * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
   *
   * @func
   * @memberOf R
   * @since v0.6.0
   * @category Function
   * @category Object
   * @sig (* -> *) -> {*} -> (* -> *)
   * @param {Function} fn The function to bind to context
   * @param {Object} thisObj The context to bind `fn` to
   * @return {Function} A function that will execute in the context of `thisObj`.
   * @see R.partial
   * @example
   *
   *      const log = R.bind(console.log, console);
   *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
   *      // logs {a: 2}
   * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
   */


  var bind =
  /*#__PURE__*/
  _curry2(function bind(fn, thisObj) {
    return _arity(fn.length, function () {
      return fn.apply(thisObj, arguments);
    });
  });

  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;

    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);

      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }

      idx += 1;
    }

    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();

    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);

      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }

      step = iter.next();
    }

    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';

  function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }

    if (_isArrayLike(list)) {
      return _arrayReduce(fn, acc, list);
    }

    if (typeof list['fantasy-land/reduce'] === 'function') {
      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    }

    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }

    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }

    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list, 'reduce');
    }

    throw new TypeError('reduce: list must be array or iterable');
  }

  var XMap =
  /*#__PURE__*/
  function () {
    function XMap(f, xf) {
      this.xf = xf;
      this.f = f;
    }

    XMap.prototype['@@transducer/init'] = _xfBase.init;
    XMap.prototype['@@transducer/result'] = _xfBase.result;

    XMap.prototype['@@transducer/step'] = function (result, input) {
      return this.xf['@@transducer/step'](result, this.f(input));
    };

    return XMap;
  }();

  var _xmap =
  /*#__PURE__*/
  _curry2(function _xmap(f, xf) {
    return new XMap(f, xf);
  });

  function _has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  var toString = Object.prototype.toString;

  var _isArguments =
  /*#__PURE__*/
  function () {
    return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
      return toString.call(x) === '[object Arguments]';
    } : function _isArguments(x) {
      return _has('callee', x);
    };
  }(); // cover IE < 9 keys issues


  var hasEnumBug = !
  /*#__PURE__*/
  {
    toString: null
  }.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug

  var hasArgsEnumBug =
  /*#__PURE__*/
  function () {
    return arguments.propertyIsEnumerable('length');
  }();

  var contains = function contains(list, item) {
    var idx = 0;

    while (idx < list.length) {
      if (list[idx] === item) {
        return true;
      }

      idx += 1;
    }

    return false;
  };
  /**
   * Returns a list containing the names of all the enumerable own properties of
   * the supplied object.
   * Note that the order of the output array is not guaranteed to be consistent
   * across different JS platforms.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Object
   * @sig {k: v} -> [k]
   * @param {Object} obj The object to extract properties from
   * @return {Array} An array of the object's own properties.
   * @see R.keysIn, R.values
   * @example
   *
   *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
   */


  var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ?
  /*#__PURE__*/
  _curry1(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
  }) :
  /*#__PURE__*/
  _curry1(function keys(obj) {
    if (Object(obj) !== obj) {
      return [];
    }

    var prop, nIdx;
    var ks = [];

    var checkArgsLength = hasArgsEnumBug && _isArguments(obj);

    for (prop in obj) {
      if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
        ks[ks.length] = prop;
      }
    }

    if (hasEnumBug) {
      nIdx = nonEnumerableProps.length - 1;

      while (nIdx >= 0) {
        prop = nonEnumerableProps[nIdx];

        if (_has(prop, obj) && !contains(ks, prop)) {
          ks[ks.length] = prop;
        }

        nIdx -= 1;
      }
    }

    return ks;
  });
  /**
   * Takes a function and
   * a [functor](https://github.com/fantasyland/fantasy-land#functor),
   * applies the function to each of the functor's values, and returns
   * a functor of the same shape.
   *
   * Ramda provides suitable `map` implementations for `Array` and `Object`,
   * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
   *
   * Dispatches to the `map` method of the second argument, if present.
   *
   * Acts as a transducer if a transformer is given in list position.
   *
   * Also treats functions as functors and will compose them together.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig Functor f => (a -> b) -> f a -> f b
   * @param {Function} fn The function to be called on every element of the input `list`.
   * @param {Array} list The list to be iterated over.
   * @return {Array} The new list.
   * @see R.transduce, R.addIndex
   * @example
   *
   *      const double = x => x * 2;
   *
   *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
   *
   *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
   * @symb R.map(f, [a, b]) = [f(a), f(b)]
   * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
   * @symb R.map(f, functor_o) = functor_o.map(f)
   */

  var map$1 =
  /*#__PURE__*/
  _curry2(
  /*#__PURE__*/
  _dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
    switch (Object.prototype.toString.call(functor)) {
      case '[object Function]':
        return curryN(functor.length, function () {
          return fn.call(this, functor.apply(this, arguments));
        });

      case '[object Object]':
        return _reduce(function (acc, key) {
          acc[key] = fn(functor[key]);
          return acc;
        }, {}, keys(functor));

      default:
        return _map(fn, functor);
    }
  }));
  /**
   * Retrieve the value at a given path.
   *
   * @func
   * @memberOf R
   * @since v0.2.0
   * @category Object
   * @typedefn Idx = String | Int
   * @sig [Idx] -> {a} -> a | Undefined
   * @param {Array} path The path to use.
   * @param {Object} obj The object to retrieve the nested property from.
   * @return {*} The data at `path`.
   * @see R.prop
   * @example
   *
   *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
   *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
   */


  var path =
  /*#__PURE__*/
  _curry2(function path(paths, obj) {
    var val = obj;
    var idx = 0;

    while (idx < paths.length) {
      if (val == null) {
        return;
      }

      val = val[paths[idx]];
      idx += 1;
    }

    return val;
  });
  /**
   * Returns a function that when supplied an object returns the indicated
   * property of that object, if it exists.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Object
   * @sig s -> {s: a} -> a | Undefined
   * @param {String} p The property name
   * @param {Object} obj The object to query
   * @return {*} The value at `obj.p`.
   * @see R.path
   * @example
   *
   *      R.prop('x', {x: 100}); //=> 100
   *      R.prop('x', {}); //=> undefined
   *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
   */


  var prop =
  /*#__PURE__*/
  _curry2(function prop(p, obj) {
    return path([p], obj);
  });
  /**
   * Returns a single item by iterating through the list, successively calling
   * the iterator function and passing it an accumulator value and the current
   * value from the array, and then passing the result to the next call.
   *
   * The iterator function receives two values: *(acc, value)*. It may use
   * [`R.reduced`](#reduced) to shortcut the iteration.
   *
   * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
   * is *(value, acc)*.
   *
   * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
   * arrays), unlike the native `Array.prototype.reduce` method. For more details
   * on this behavior, see:
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
   *
   * Dispatches to the `reduce` method of the third argument, if present. When
   * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
   * shortcuting, as this is not implemented by `reduce`.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig ((a, b) -> a) -> a -> [b] -> a
   * @param {Function} fn The iterator function. Receives two values, the accumulator and the
   *        current element from the array.
   * @param {*} acc The accumulator value.
   * @param {Array} list The list to iterate over.
   * @return {*} The final, accumulated value.
   * @see R.reduced, R.addIndex, R.reduceRight
   * @example
   *
   *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
   *      //          -               -10
   *      //         / \              / \
   *      //        -   4           -6   4
   *      //       / \              / \
   *      //      -   3   ==>     -3   3
   *      //     / \              / \
   *      //    -   2           -1   2
   *      //   / \              / \
   *      //  0   1            0   1
   *
   * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
   */


  var reduce =
  /*#__PURE__*/
  _curry3(_reduce);
  /**
   * Returns a function that always returns the given value. Note that for
   * non-primitives the value returned is a reference to the original value.
   *
   * This function is known as `const`, `constant`, or `K` (for K combinator) in
   * other languages and libraries.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig a -> (* -> a)
   * @param {*} val The value to wrap in a function
   * @return {Function} A Function :: * -> val.
   * @example
   *
   *      const t = R.always('Tee');
   *      t(); //=> 'Tee'
   */


  var always =
  /*#__PURE__*/
  _curry1(function always(val) {
    return function () {
      return val;
    };
  });
  /**
   * ap applies a list of functions to a list of values.
   *
   * Dispatches to the `ap` method of the second argument, if present. Also
   * treats curried functions as applicatives.
   *
   * @func
   * @memberOf R
   * @since v0.3.0
   * @category Function
   * @sig [a -> b] -> [a] -> [b]
   * @sig Apply f => f (a -> b) -> f a -> f b
   * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
   * @param {*} applyF
   * @param {*} applyX
   * @return {*}
   * @example
   *
   *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
   *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
   *
   *      // R.ap can also be used as S combinator
   *      // when only two functions are passed
   *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
   * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
   */


  var ap =
  /*#__PURE__*/
  _curry2(function ap(applyF, applyX) {
    return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function (x) {
      return applyF(x)(applyX(x));
    } : _reduce(function (acc, f) {
      return _concat(acc, map$1(f, applyX));
    }, [], applyF);
  });
  /**
   * Checks if the input value is `null` or `undefined`.
   *
   * @func
   * @memberOf R
   * @since v0.9.0
   * @category Type
   * @sig * -> Boolean
   * @param {*} x The value to test.
   * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
   * @example
   *
   *      R.isNil(null); //=> true
   *      R.isNil(undefined); //=> true
   *      R.isNil(0); //=> false
   *      R.isNil([]); //=> false
   */


  var isNil =
  /*#__PURE__*/
  _curry1(function isNil(x) {
    return x == null;
  });
  /**
   * "lifts" a function to be the specified arity, so that it may "map over" that
   * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
   *
   * @func
   * @memberOf R
   * @since v0.7.0
   * @category Function
   * @sig Number -> (*... -> *) -> ([*]... -> [*])
   * @param {Function} fn The function to lift into higher context
   * @return {Function} The lifted function.
   * @see R.lift, R.ap
   * @example
   *
   *      const madd3 = R.liftN(3, (...args) => R.sum(args));
   *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
   */


  var liftN =
  /*#__PURE__*/
  _curry2(function liftN(arity, fn) {
    var lifted = curryN(arity, fn);
    return curryN(arity, function () {
      return _reduce(ap, map$1(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
  });
  /**
   * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
   * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
   *
   * @func
   * @memberOf R
   * @since v0.7.0
   * @category Function
   * @sig (*... -> *) -> ([*]... -> [*])
   * @param {Function} fn The function to lift into higher context
   * @return {Function} The lifted function.
   * @see R.liftN
   * @example
   *
   *      const madd3 = R.lift((a, b, c) => a + b + c);
   *
   *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
   *
   *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
   *
   *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
   */


  var lift =
  /*#__PURE__*/
  _curry1(function lift(fn) {
    return liftN(fn.length, fn);
  });
  /**
   * Gives a single-word string description of the (native) type of a value,
   * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
   * attempt to distinguish user Object types any further, reporting them all as
   * 'Object'.
   *
   * @func
   * @memberOf R
   * @since v0.8.0
   * @category Type
   * @sig (* -> {*}) -> String
   * @param {*} val The value to test
   * @return {String}
   * @example
   *
   *      R.type({}); //=> "Object"
   *      R.type(1); //=> "Number"
   *      R.type(false); //=> "Boolean"
   *      R.type('s'); //=> "String"
   *      R.type(null); //=> "Null"
   *      R.type([]); //=> "Array"
   *      R.type(/[A-z]/); //=> "RegExp"
   *      R.type(() => {}); //=> "Function"
   *      R.type(undefined); //=> "Undefined"
   */


  var type =
  /*#__PURE__*/
  _curry1(function type(val) {
    return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
  });
  /**
   * A function that returns the `!` of its argument. It will return `true` when
   * passed false-y value, and `false` when passed a truth-y one.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Logic
   * @sig * -> Boolean
   * @param {*} a any value
   * @return {Boolean} the logical inverse of passed argument.
   * @see R.complement
   * @example
   *
   *      R.not(true); //=> false
   *      R.not(false); //=> true
   *      R.not(0); //=> true
   *      R.not(1); //=> false
   */


  var not =
  /*#__PURE__*/
  _curry1(function not(a) {
    return !a;
  });
  /**
   * Takes a function `f` and returns a function `g` such that if called with the same arguments
   * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
   *
   * `R.complement` may be applied to any functor
   *
   * @func
   * @memberOf R
   * @since v0.12.0
   * @category Logic
   * @sig (*... -> *) -> (*... -> Boolean)
   * @param {Function} f
   * @return {Function}
   * @see R.not
   * @example
   *
   *      const isNotNil = R.complement(R.isNil);
   *      isNil(null); //=> true
   *      isNotNil(null); //=> false
   *      isNil(7); //=> false
   *      isNotNil(7); //=> true
   */


  var complement =
  /*#__PURE__*/
  lift(not);

  function _pipe(f, g) {
    return function () {
      return g.call(this, f.apply(this, arguments));
    };
  }
  /**
   * This checks whether a function has a [methodname] function. If it isn't an
   * array it will execute that function otherwise it will default to the ramda
   * implementation.
   *
   * @private
   * @param {Function} fn ramda implemtation
   * @param {String} methodname property to check for a custom implementation
   * @return {Object} Whatever the return value of the method is.
   */


  function _checkForMethod(methodname, fn) {
    return function () {
      var length = arguments.length;

      if (length === 0) {
        return fn();
      }

      var obj = arguments[length - 1];
      return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
  }
  /**
   * Returns the elements of the given list or string (or object with a `slice`
   * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
   *
   * Dispatches to the `slice` method of the third argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.4
   * @category List
   * @sig Number -> Number -> [a] -> [a]
   * @sig Number -> Number -> String -> String
   * @param {Number} fromIndex The start index (inclusive).
   * @param {Number} toIndex The end index (exclusive).
   * @param {*} list
   * @return {*}
   * @example
   *
   *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
   *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
   *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
   *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
   *      R.slice(0, 3, 'ramda');                     //=> 'ram'
   */


  var slice =
  /*#__PURE__*/
  _curry3(
  /*#__PURE__*/
  _checkForMethod('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
  }));
  /**
   * Returns all but the first element of the given list or string (or object
   * with a `tail` method).
   *
   * Dispatches to the `slice` method of the first argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig [a] -> [a]
   * @sig String -> String
   * @param {*} list
   * @return {*}
   * @see R.head, R.init, R.last
   * @example
   *
   *      R.tail([1, 2, 3]);  //=> [2, 3]
   *      R.tail([1, 2]);     //=> [2]
   *      R.tail([1]);        //=> []
   *      R.tail([]);         //=> []
   *
   *      R.tail('abc');  //=> 'bc'
   *      R.tail('ab');   //=> 'b'
   *      R.tail('a');    //=> ''
   *      R.tail('');     //=> ''
   */


  var tail =
  /*#__PURE__*/
  _curry1(
  /*#__PURE__*/
  _checkForMethod('tail',
  /*#__PURE__*/
  slice(1, Infinity)));
  /**
   * Performs left-to-right function composition. The leftmost function may have
   * any arity; the remaining functions must be unary.
   *
   * In some libraries this function is named `sequence`.
   *
   * **Note:** The result of pipe is not automatically curried.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
   * @param {...Function} functions
   * @return {Function}
   * @see R.compose
   * @example
   *
   *      const f = R.pipe(Math.pow, R.negate, R.inc);
   *
   *      f(3, 4); // -(3^4) + 1
   * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
   */


  function pipe() {
    if (arguments.length === 0) {
      throw new Error('pipe requires at least one argument');
    }

    return _arity(arguments[0].length, reduce(_pipe, arguments[0], tail(arguments)));
  }

  function _identity(x) {
    return x;
  }
  /**
   * A function that does nothing but return the parameter supplied to it. Good
   * as a default or placeholder function.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig a -> a
   * @param {*} x The value to return.
   * @return {*} The input value, `x`.
   * @example
   *
   *      R.identity(1); //=> 1
   *
   *      const obj = {};
   *      R.identity(obj) === obj; //=> true
   * @symb R.identity(a) = a
   */


  var identity =
  /*#__PURE__*/
  _curry1(_identity);

  function _arrayFromIterator(iter) {
    var list = [];
    var next;

    while (!(next = iter.next()).done) {
      list.push(next.value);
    }

    return list;
  }

  function _includesWith(pred, x, list) {
    var idx = 0;
    var len = list.length;

    while (idx < len) {
      if (pred(x, list[idx])) {
        return true;
      }

      idx += 1;
    }

    return false;
  }

  function _functionName(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? '' : match[1];
  } // Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is


  function _objectIs(a, b) {
    // SameValue algorithm
    if (a === b) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return a !== 0 || 1 / a === 1 / b;
    } else {
      // Step 6.a: NaN == NaN
      return a !== a && b !== b;
    }
  }

  var _objectIs$1 = typeof Object.is === 'function' ? Object.is : _objectIs;
  /**
   * private _uniqContentEquals function.
   * That function is checking equality of 2 iterator contents with 2 assumptions
   * - iterators lengths are the same
   * - iterators values are unique
   *
   * false-positive result will be returned for comparision of, e.g.
   * - [1,2,3] and [1,2,3,4]
   * - [1,1,1] and [1,2,3]
   * */


  function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = _arrayFromIterator(aIterator);

    var b = _arrayFromIterator(bIterator);

    function eq(_a, _b) {
      return _equals(_a, _b, stackA.slice(), stackB.slice());
    } // if *a* array contains any element that is not included in *b*


    return !_includesWith(function (b, aItem) {
      return !_includesWith(eq, aItem, b);
    }, b, a);
  }

  function _equals(a, b, stackA, stackB) {
    if (_objectIs$1(a, b)) {
      return true;
    }

    var typeA = type(a);

    if (typeA !== type(b)) {
      return false;
    }

    if (a == null || b == null) {
      return false;
    }

    if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
      return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
    }

    if (typeof a.equals === 'function' || typeof b.equals === 'function') {
      return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
    }

    switch (typeA) {
      case 'Arguments':
      case 'Array':
      case 'Object':
        if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
          return a === b;
        }

        break;

      case 'Boolean':
      case 'Number':
      case 'String':
        if (!(typeof a === typeof b && _objectIs$1(a.valueOf(), b.valueOf()))) {
          return false;
        }

        break;

      case 'Date':
        if (!_objectIs$1(a.valueOf(), b.valueOf())) {
          return false;
        }

        break;

      case 'Error':
        return a.name === b.name && a.message === b.message;

      case 'RegExp':
        if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
          return false;
        }

        break;
    }

    var idx = stackA.length - 1;

    while (idx >= 0) {
      if (stackA[idx] === a) {
        return stackB[idx] === b;
      }

      idx -= 1;
    }

    switch (typeA) {
      case 'Map':
        if (a.size !== b.size) {
          return false;
        }

        return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));

      case 'Set':
        if (a.size !== b.size) {
          return false;
        }

        return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));

      case 'Arguments':
      case 'Array':
      case 'Object':
      case 'Boolean':
      case 'Number':
      case 'String':
      case 'Date':
      case 'Error':
      case 'RegExp':
      case 'Int8Array':
      case 'Uint8Array':
      case 'Uint8ClampedArray':
      case 'Int16Array':
      case 'Uint16Array':
      case 'Int32Array':
      case 'Uint32Array':
      case 'Float32Array':
      case 'Float64Array':
      case 'ArrayBuffer':
        break;

      default:
        // Values of other types are only equal if identical.
        return false;
    }

    var keysA = keys(a);

    if (keysA.length !== keys(b).length) {
      return false;
    }

    var extendedStackA = stackA.concat([a]);
    var extendedStackB = stackB.concat([b]);
    idx = keysA.length - 1;

    while (idx >= 0) {
      var key = keysA[idx];

      if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
        return false;
      }

      idx -= 1;
    }

    return true;
  }
  /**
   * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
   * cyclical data structures.
   *
   * Dispatches symmetrically to the `equals` methods of both arguments, if
   * present.
   *
   * @func
   * @memberOf R
   * @since v0.15.0
   * @category Relation
   * @sig a -> b -> Boolean
   * @param {*} a
   * @param {*} b
   * @return {Boolean}
   * @example
   *
   *      R.equals(1, 1); //=> true
   *      R.equals(1, '1'); //=> false
   *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
   *
   *      const a = {}; a.v = a;
   *      const b = {}; b.v = b;
   *      R.equals(a, b); //=> true
   */


  var equals =
  /*#__PURE__*/
  _curry2(function equals(a, b) {
    return _equals(a, b, [], []);
  });

  function _isObject(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
  }
  /**
   * Returns the second argument if it is not `null`, `undefined` or `NaN`;
   * otherwise the first argument is returned.
   *
   * @func
   * @memberOf R
   * @since v0.10.0
   * @category Logic
   * @sig a -> b -> a | b
   * @param {a} default The default value.
   * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
   * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
   * @example
   *
   *      const defaultTo42 = R.defaultTo(42);
   *
   *      defaultTo42(null);  //=> 42
   *      defaultTo42(undefined);  //=> 42
   *      defaultTo42(false);  //=> false
   *      defaultTo42('Ramda');  //=> 'Ramda'
   *      // parseInt('string') results in NaN
   *      defaultTo42(parseInt('string')); //=> 42
   */


  var defaultTo =
  /*#__PURE__*/
  _curry2(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
  });
  /**
   * Returns the empty value of its argument's type. Ramda defines the empty
   * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
   * types are supported if they define `<Type>.empty`,
   * `<Type>.prototype.empty` or implement the
   * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
   *
   * Dispatches to the `empty` method of the first argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.3.0
   * @category Function
   * @sig a -> a
   * @param {*} x
   * @return {*}
   * @example
   *
   *      R.empty(Just(42));      //=> Nothing()
   *      R.empty([1, 2, 3]);     //=> []
   *      R.empty('unicorns');    //=> ''
   *      R.empty({x: 1, y: 2});  //=> {}
   */


  var empty =
  /*#__PURE__*/
  _curry1(function empty(x) {
    return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : _isArray(x) ? [] : _isString(x) ? '' : _isObject(x) ? {} : _isArguments(x) ? function () {
      return arguments;
    }() : void 0 // else
    ;
  });

  var XFind =
  /*#__PURE__*/
  function () {
    function XFind(f, xf) {
      this.xf = xf;
      this.f = f;
      this.found = false;
    }

    XFind.prototype['@@transducer/init'] = _xfBase.init;

    XFind.prototype['@@transducer/result'] = function (result) {
      if (!this.found) {
        result = this.xf['@@transducer/step'](result, void 0);
      }

      return this.xf['@@transducer/result'](result);
    };

    XFind.prototype['@@transducer/step'] = function (result, input) {
      if (this.f(input)) {
        this.found = true;
        result = _reduced(this.xf['@@transducer/step'](result, input));
      }

      return result;
    };

    return XFind;
  }();

  var _xfind =
  /*#__PURE__*/
  _curry2(function _xfind(f, xf) {
    return new XFind(f, xf);
  });
  /**
   * Returns the first element of the list which matches the predicate, or
   * `undefined` if no element matches.
   *
   * Dispatches to the `find` method of the second argument, if present.
   *
   * Acts as a transducer if a transformer is given in list position.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig (a -> Boolean) -> [a] -> a | undefined
   * @param {Function} fn The predicate function used to determine if the element is the
   *        desired one.
   * @param {Array} list The array to consider.
   * @return {Object} The element found, or `undefined`.
   * @see R.transduce
   * @example
   *
   *      const xs = [{a: 1}, {a: 2}, {a: 3}];
   *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
   *      R.find(R.propEq('a', 4))(xs); //=> undefined
   */


  var find =
  /*#__PURE__*/
  _curry2(
  /*#__PURE__*/
  _dispatchable(['find'], _xfind, function find(fn, list) {
    var idx = 0;
    var len = list.length;

    while (idx < len) {
      if (fn(list[idx])) {
        return list[idx];
      }

      idx += 1;
    }
  }));
  /**
   * Creates a function that will process either the `onTrue` or the `onFalse`
   * function depending upon the result of the `condition` predicate.
   *
   * @func
   * @memberOf R
   * @since v0.8.0
   * @category Logic
   * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
   * @param {Function} condition A predicate function
   * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
   * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
   * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
   *                    function depending upon the result of the `condition` predicate.
   * @see R.unless, R.when, R.cond
   * @example
   *
   *      const incCount = R.ifElse(
   *        R.has('count'),
   *        R.over(R.lensProp('count'), R.inc),
   *        R.assoc('count', 1)
   *      );
   *      incCount({});           //=> { count: 1 }
   *      incCount({ count: 1 }); //=> { count: 2 }
   */


  var ifElse =
  /*#__PURE__*/
  _curry3(function ifElse(condition, onTrue, onFalse) {
    return curryN(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
  });
  /**
   * See if an object (`val`) is an instance of the supplied constructor. This
   * function will check up the inheritance chain, if any.
   *
   * @func
   * @memberOf R
   * @since v0.3.0
   * @category Type
   * @sig (* -> {*}) -> a -> Boolean
   * @param {Object} ctor A constructor
   * @param {*} val The value to test
   * @return {Boolean}
   * @example
   *
   *      R.is(Object, {}); //=> true
   *      R.is(Number, 1); //=> true
   *      R.is(Object, 1); //=> false
   *      R.is(String, 's'); //=> true
   *      R.is(String, new String('')); //=> true
   *      R.is(Object, new String('')); //=> true
   *      R.is(Object, 's'); //=> false
   *      R.is(Number, {}); //=> false
   */


  var is =
  /*#__PURE__*/
  _curry2(function is(Ctor, val) {
    return val != null && val.constructor === Ctor || val instanceof Ctor;
  });
  /**
   * Returns `true` if the given value is its type's empty value; `false`
   * otherwise.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Logic
   * @sig a -> Boolean
   * @param {*} x
   * @return {Boolean}
   * @see R.empty
   * @example
   *
   *      R.isEmpty([1, 2, 3]);   //=> false
   *      R.isEmpty([]);          //=> true
   *      R.isEmpty('');          //=> true
   *      R.isEmpty(null);        //=> false
   *      R.isEmpty({});          //=> true
   *      R.isEmpty({length: 0}); //=> false
   */


  var isEmpty =
  /*#__PURE__*/
  _curry1(function isEmpty(x) {
    return x != null && equals(x, empty(x));
  });
  /**
   * If the given, non-null object has a value at the given path, returns the
   * value at that path. Otherwise returns the provided default value.
   *
   * @func
   * @memberOf R
   * @since v0.18.0
   * @category Object
   * @typedefn Idx = String | Int
   * @sig a -> [Idx] -> {a} -> a
   * @param {*} d The default value.
   * @param {Array} p The path to use.
   * @param {Object} obj The object to retrieve the nested property from.
   * @return {*} The data at `path` of the supplied object or the default value.
   * @example
   *
   *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
   *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
   */


  var pathOr =
  /*#__PURE__*/
  _curry3(function pathOr(d, p, obj) {
    return defaultTo(d, path(p, obj));
  });
  /**
   * Similar to `pick` except that this one includes a `key: undefined` pair for
   * properties that don't exist.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Object
   * @sig [k] -> {k: v} -> {k: v}
   * @param {Array} names an array of String property names to copy onto a new object
   * @param {Object} obj The object to copy from
   * @return {Object} A new object with only properties from `names` on it.
   * @see R.pick
   * @example
   *
   *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
   *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
   */


  var pickAll =
  /*#__PURE__*/
  _curry2(function pickAll(names, obj) {
    var result = {};
    var idx = 0;
    var len = names.length;

    while (idx < len) {
      var name = names[idx];
      result[name] = obj[name];
      idx += 1;
    }

    return result;
  });
  /**
   * Returns a partial copy of an object containing only the keys that satisfy
   * the supplied predicate.
   *
   * @func
   * @memberOf R
   * @since v0.8.0
   * @category Object
   * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
   * @param {Function} pred A predicate to determine whether or not a key
   *        should be included on the output object.
   * @param {Object} obj The object to copy from
   * @return {Object} A new object with only properties that satisfy `pred`
   *         on it.
   * @see R.pick, R.filter
   * @example
   *
   *      const isUpperCase = (val, key) => key.toUpperCase() === key;
   *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
   */


  var pickBy =
  /*#__PURE__*/
  _curry2(function pickBy(test, obj) {
    var result = {};

    for (var prop in obj) {
      if (test(obj[prop], prop, obj)) {
        result[prop] = obj[prop];
      }
    }

    return result;
  });
  /**
   * If the given, non-null object has an own property with the specified name,
   * returns the value of that property. Otherwise returns the provided default
   * value.
   *
   * @func
   * @memberOf R
   * @since v0.6.0
   * @category Object
   * @sig a -> String -> Object -> a
   * @param {*} val The default value.
   * @param {String} p The name of the property to return.
   * @param {Object} obj The object to query.
   * @return {*} The value of given property of the supplied object or the default value.
   * @example
   *
   *      const alice = {
   *        name: 'ALICE',
   *        age: 101
   *      };
   *      const favorite = R.prop('favoriteLibrary');
   *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
   *
   *      favorite(alice);  //=> undefined
   *      favoriteWithDefault(alice);  //=> 'Ramda'
   */


  var propOr =
  /*#__PURE__*/
  _curry3(function propOr(val, p, obj) {
    return pathOr(val, [p], obj);
  });

  var getStyles$1 = function getStyles() {
    return {
      iconStyles: {
        width: 40,
        height: 40,
        userSelect: 'none'
      },
      expandButtonStyles: {
        padding: '10px 0 20px',
        textDecoration: 'underline',
        cursor: 'pointer'
      }
    };
  };

  var AccordionContext = React.createContext({});

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var _ref =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M25.857 17L28 19.083 18.828 28H45v3H18.828L28 39.917 25.857 42 13 29.5 25.857 17z"
  });

  var SvgArrowLeft = function SvgArrowLeft(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends({
        viewBox: "0 0 60 60"
      }, props), _ref)
    );
  };

  var getStyles$2 = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  var ArrowLeftIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ArrowLeftIconComponent, _PureComponent);

    var _super = _createSuper(ArrowLeftIconComponent);

    function ArrowLeftIconComponent() {
      _classCallCheck(this, ArrowLeftIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(ArrowLeftIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$2(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgArrowLeft, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return ArrowLeftIconComponent;
  }(React.PureComponent);

  var ArrowLeftIcon = withStyles(ArrowLeftIconComponent);

  function _extends$1() {
    _extends$1 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$1.apply(this, arguments);
  }

  var _ref$1 =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M34.143 17L32 19.083 41.172 28H15v3h26.172L32 39.917 34.143 42 47 29.5 34.143 17z"
  });

  var SvgArrowRight = function SvgArrowRight(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$1({
        viewBox: "0 0 60 60"
      }, props), _ref$1)
    );
  };

  var getStyles$3 = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  var ArrowRightIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ArrowRightIconComponent, _PureComponent);

    var _super = _createSuper(ArrowRightIconComponent);

    function ArrowRightIconComponent() {
      _classCallCheck(this, ArrowRightIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(ArrowRightIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$3(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgArrowRight, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return ArrowRightIconComponent;
  }(React.PureComponent);

  var ArrowRightIcon = withStyles(ArrowRightIconComponent);

  function _extends$2() {
    _extends$2 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$2.apply(this, arguments);
  }

  var _ref$2 =
  /*#__PURE__*/
  React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M39.192 17.98l2.829 2.828L32.828 30l9.193 9.192-2.829 2.829L30 32.828l-9.192 9.193-2.829-2.829L27.172 30l-9.193-9.192 2.829-2.829L30 27.172l9.192-9.193z"
  });

  var SvgClose = function SvgClose(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$2({
        viewBox: "0 0 60 60"
      }, props), _ref$2)
    );
  };

  var getStyles$4 = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  var CloseIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CloseIconComponent, _PureComponent);

    var _super = _createSuper(CloseIconComponent);

    function CloseIconComponent() {
      _classCallCheck(this, CloseIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(CloseIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$4(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgClose, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return CloseIconComponent;
  }(React.PureComponent);

  var CloseIcon = withStyles(CloseIconComponent);

  function _extends$3() {
    _extends$3 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$3.apply(this, arguments);
  }

  var _ref$3 =
  /*#__PURE__*/
  React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M33 8v9.332l.005.195A3.67 3.67 0 0036.668 21H46v27.902A3.106 3.106 0 0142.887 52H17.113A3.106 3.106 0 0114 48.902V10.48A2.484 2.484 0 0116.492 8H33zm7 20H20v17h20V28zM29 40v3h-7v-3h7zm9 0v3h-7v-3h7zm-9-5v3h-7v-3h7zm9 0v3h-7v-3h7zm-9-5v3h-7v-3h7zm9 0v3h-7v-3h7zm7.5-11h-8.832l-.144-.006A1.67 1.67 0 0135 17.332V8.5L45.5 19z"
  });

  var SvgSpreadsheet = function SvgSpreadsheet(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$3({
        viewBox: "0 0 60 60"
      }, props), _ref$3)
    );
  };

  var getStyles$5 = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  var CsvIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CsvIconComponent, _PureComponent);

    var _super = _createSuper(CsvIconComponent);

    function CsvIconComponent() {
      _classCallCheck(this, CsvIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(CsvIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$5(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgSpreadsheet, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return CsvIconComponent;
  }(React.PureComponent);

  var CsvIcon = withStyles(CsvIconComponent);

  function _extends$4() {
    _extends$4 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$4.apply(this, arguments);
  }

  var _ref$4 =
  /*#__PURE__*/
  React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M21.789 10.92a.724.724 0 000-1.022l-1.687-1.687a.724.724 0 00-1.022 0l-1.322 1.322 2.709 2.709 1.322-1.322zM9 18.291V21h2.709l7.992-7.992-2.709-2.71L9 18.292z"
  });

  var SvgEdit = function SvgEdit(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$4({
        viewBox: "0 0 30 30"
      }, props), _ref$4)
    );
  };

  var getStyles$6 = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '30px',
      height: '30px'
    };
  };

  var EditIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(EditIconComponent, _PureComponent);

    var _super = _createSuper(EditIconComponent);

    function EditIconComponent() {
      _classCallCheck(this, EditIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(EditIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$6(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgEdit, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return EditIconComponent;
  }(React.PureComponent);

  var EditIcon = withStyles(EditIconComponent);

  var getStyles$7 = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: 24,
      height: 21
    };
  };

  function _extends$5() {
    _extends$5 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$5.apply(this, arguments);
  }

  var _ref$5 =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M0 0h15v6h-1V1H1v19h13v-5h1v6H0z"
  });

  var _ref2 =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M8 10h15v1H8z"
  });

  var _ref3 =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M24 10.5L19 6l-.5 1 4 3.5-4 3.5.5 1z"
  });

  var SvgExit = function SvgExit(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$5({
        viewBox: "0 0 24 21"
      }, props), _ref$5, _ref2, _ref3)
    );
  };

  var ExitIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ExitIconComponent, _PureComponent);

    var _super = _createSuper(ExitIconComponent);

    function ExitIconComponent() {
      _classCallCheck(this, ExitIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(ExitIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$7(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgExit, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return ExitIconComponent;
  }(React.PureComponent);

  var ExitIcon = withStyles(ExitIconComponent);

  function _extends$6() {
    _extends$6 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$6.apply(this, arguments);
  }

  var _ref$6 =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M11 23a8 8 0 100-16 8 8 0 000 16zm0-1a7 7 0 110-14 7 7 0 010 14z"
  });

  var _ref2$1 =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M19 23a8 8 0 100-16 8 8 0 000 16zm0-1a7 7 0 110-14 7 7 0 010 14z"
  });

  var SvgIntersect = function SvgIntersect(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$6({
        viewBox: "0 0 30 30"
      }, props), _ref$6, _ref2$1)
    );
  };

  var getStyles$8 = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '30px',
      height: '30px'
    };
  };

  var IntersectIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(IntersectIconComponent, _PureComponent);

    var _super = _createSuper(IntersectIconComponent);

    function IntersectIconComponent() {
      _classCallCheck(this, IntersectIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(IntersectIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$8(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgIntersect, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return IntersectIconComponent;
  }(React.PureComponent);

  var IntersectIcon = withStyles(IntersectIconComponent);

  function _extends$7() {
    _extends$7 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$7.apply(this, arguments);
  }

  var _ref$7 =
  /*#__PURE__*/
  React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M5 37a3 3 0 110 6 3 3 0 010-6zm0-10a3 3 0 110 6 3 3 0 010-6zm0-10a3 3 0 110 6 3 3 0 010-6z"
  });

  var SvgMenu = function SvgMenu(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$7({
        viewBox: "0 0 10 60"
      }, props), _ref$7)
    );
  };

  var getStyles$9 = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  var MenuIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(MenuIconComponent, _PureComponent);

    var _super = _createSuper(MenuIconComponent);

    function MenuIconComponent() {
      _classCallCheck(this, MenuIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(MenuIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$9(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgMenu, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return MenuIconComponent;
  }(React.PureComponent);

  var MenuIcon = withStyles(MenuIconComponent);

  function _extends$8() {
    _extends$8 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$8.apply(this, arguments);
  }

  var _ref$8 =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M15 28h30v4H15z"
  });

  var SvgMinus = function SvgMinus(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$8({
        viewBox: "0 0 60 60"
      }, props), _ref$8)
    );
  };

  var getStyles$a = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    var inverse = arguments.length > 1 ? arguments[1] : undefined;
    return {
      fill: inverse ? theme.icon.fillInverse : theme.icon.fill,
      width: 30,
      height: 30,
      shapeRendering: 'crispEdges'
    };
  };

  var MinusIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(MinusIconComponent, _PureComponent);

    var _super = _createSuper(MinusIconComponent);

    function MinusIconComponent() {
      _classCallCheck(this, MinusIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(MinusIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            inverse = _this$props.inverse,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme", "inverse"]);

        var containerStyles = getStyles$a(theme, inverse);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgMinus, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return MinusIconComponent;
  }(React.PureComponent);

  MinusIconComponent.defaultProps = {
    inverse: false
  };
  var MinusIcon = withStyles(MinusIconComponent);

  function _extends$9() {
    _extends$9 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$9.apply(this, arguments);
  }

  var _ref$9 =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M32 15v13h13v4H32v13h-4V32H15v-4h13V15h4z"
  });

  var SvgPlus = function SvgPlus(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$9({
        viewBox: "0 0 60 60"
      }, props), _ref$9)
    );
  };

  var getStyles$b = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    var inverse = arguments.length > 1 ? arguments[1] : undefined;
    return {
      fill: inverse ? theme.icon.fillInverse : theme.icon.fill,
      width: '60px',
      height: '60px',
      shapeRendering: 'crispEdges'
    };
  };

  var PlusIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(PlusIconComponent, _PureComponent);

    var _super = _createSuper(PlusIconComponent);

    function PlusIconComponent() {
      _classCallCheck(this, PlusIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(PlusIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            inverse = _this$props.inverse,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme", "inverse"]);

        var containerStyles = getStyles$b(theme, inverse);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgPlus, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return PlusIconComponent;
  }(React.PureComponent);

  PlusIconComponent.defaultProps = {
    inverse: false
  };
  var PlusIcon = withStyles(PlusIconComponent);

  var getStyles$c = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '28px',
      height: '28px'
    };
  };

  function _extends$a() {
    _extends$a = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$a.apply(this, arguments);
  }

  var _ref$a =
  /*#__PURE__*/
  React__default.createElement("defs", null,
  /*#__PURE__*/
  React__default.createElement("path", {
    id: "user_svg__a",
    d: "M0 0h24.034v24.034H0z"
  }));

  var _ref2$2 =
  /*#__PURE__*/
  React__default.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(1.867 1.867)"
  },
  /*#__PURE__*/
  React__default.createElement("mask", {
    id: "user_svg__b",
    fill: "#fff"
  },
  /*#__PURE__*/
  React__default.createElement("use", {
    xlinkHref: "#user_svg__a"
  })),
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M4.138 19.57c1.38-.552 2.677-1.04 3.948-1.588 1.495-.646 1.735-1.708.889-3.134-.632-1.065-1.361-2.162-1.616-3.34-.284-1.311-.117-2.73-.081-4.1.068-2.682 1.755-4.263 4.561-4.268 2.074-.004 5.335 1.606 5.025 4.192-.274 2.283.356 4.774-1.347 6.785-.193.229-.308.523-.474.777-.886 1.37-.568 2.463.95 3.104 1.273.537 2.566 1.029 3.863 1.545 4.067-3.565 4.198-10.59.257-14.93C15.993.079 8.887-.158 4.432 4.09.044 8.275-.1 15.32 4.138 19.57M0 11.9C.053 5.289 5.524-.063 12.165 0c6.606.064 11.94 5.543 11.868 12.195-.07 6.542-5.517 11.874-12.098 11.84C5.326 24-.052 18.531 0 11.9",
    mask: "url(#user_svg__b)"
  }));

  var SvgUser = function SvgUser(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$a({
        viewBox: "0 0 28 28"
      }, props), _ref$a, _ref2$2)
    );
  };

  var UserIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(UserIconComponent, _PureComponent);

    var _super = _createSuper(UserIconComponent);

    function UserIconComponent() {
      _classCallCheck(this, UserIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(UserIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$c(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgUser, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return UserIconComponent;
  }(React.PureComponent);

  var UserIcon = withStyles(UserIconComponent);

  var getStyles$d = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  function _extends$b() {
    _extends$b = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$b.apply(this, arguments);
  }

  var _ref$b =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M16 42V32h3v7h23v-7h3v10H16zm14.5-30.121l9.06 9.06-2.12 2.122-5.441-5.441L32 33h-3l-.001-15.378-5.438 5.439-2.122-2.122 9.061-9.06z"
  });

  var SvgUpload = function SvgUpload(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$b({
        viewBox: "16 11.879 29 30.121"
      }, props), _ref$b)
    );
  };

  var UploadIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(UploadIconComponent, _PureComponent);

    var _super = _createSuper(UploadIconComponent);

    function UploadIconComponent() {
      _classCallCheck(this, UploadIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(UploadIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$d(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgUpload, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return UploadIconComponent;
  }(React.PureComponent);

  var UploadIcon = withStyles(UploadIconComponent);

  function _extends$c() {
    _extends$c = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$c.apply(this, arguments);
  }

  var _ref$c =
  /*#__PURE__*/
  React__default.createElement("path", {
    fill: "none",
    d: "M7.5 7.5h15v15h-15z"
  });

  var SvgCheckboxOff = function SvgCheckboxOff(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$c({
        viewBox: "0 0 30 30"
      }, props), _ref$c)
    );
  };

  var getStyles$e = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      stroke: theme.icon.fill,
      width: '30px',
      height: '30px'
    };
  };

  var CheckboxOffIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CheckboxOffIconComponent, _PureComponent);

    var _super = _createSuper(CheckboxOffIconComponent);

    function CheckboxOffIconComponent() {
      _classCallCheck(this, CheckboxOffIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(CheckboxOffIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$e(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgCheckboxOff, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return CheckboxOffIconComponent;
  }(React.PureComponent);

  var CheckboxOffIcon = withStyles(CheckboxOffIconComponent);

  function _extends$d() {
    _extends$d = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$d.apply(this, arguments);
  }

  var _ref$d =
  /*#__PURE__*/
  React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  },
  /*#__PURE__*/
  React__default.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M20.455 7.5H7.5v15h15v-6.136"
  }),
  /*#__PURE__*/
  React__default.createElement("path", {
    strokeWidth: 3,
    d: "M11 12l5 5L26 7"
  }));

  var SvgCheckboxOn = function SvgCheckboxOn(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$d({
        viewBox: "0 0 30 30",
        stroke: "#000"
      }, props), _ref$d)
    );
  };

  var getStyles$f = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      stroke: theme.icon.fill,
      width: '30px',
      height: '30px'
    };
  };

  var CheckboxOnIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CheckboxOnIconComponent, _PureComponent);

    var _super = _createSuper(CheckboxOnIconComponent);

    function CheckboxOnIconComponent() {
      _classCallCheck(this, CheckboxOnIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(CheckboxOnIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$f(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgCheckboxOn, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return CheckboxOnIconComponent;
  }(React.PureComponent);

  var CheckboxOnIcon = withStyles(CheckboxOnIconComponent);

  function _extends$e() {
    _extends$e = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$e.apply(this, arguments);
  }

  var _ref$e =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M25.976 15.668l-.013.036a.536.536 0 01-.065.122C22.904 19.934 19.263 22 15 22s-7.904-2.066-10.898-6.174l-.022-.034a.515.515 0 01-.024-.043l.046.077a.52.52 0 01-.078-.158l-.004-.015a.57.57 0 01.007-.33.533.533 0 01.056-.12l-.042.083a.53.53 0 01.024-.052l.018-.031C7.073 10.415 10.722 8 15 8s7.927 2.415 10.917 7.203a.52.52 0 01.079.225.628.628 0 01-.016.225l-.004.015zM15 9c-3.995 0-7.398 2.252-10.237 6.797l.204-.322.028.037C7.781 19.178 11.107 21 15 21c3.906 0 7.241-1.834 10.032-5.524C22.235 11.146 18.9 9 15 9z"
  });

  var _ref2$3 =
  /*#__PURE__*/
  React__default.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 4.5,
    fill: "none"
  });

  var SvgEye = function SvgEye(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$e({
        viewBox: "0 0 30 30"
      }, props), _ref$e, _ref2$3)
    );
  };

  var getStyles$g = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      stroke: theme.icon.fill,
      width: '30px',
      height: '30px'
    };
  };

  var EyeIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(EyeIconComponent, _PureComponent);

    var _super = _createSuper(EyeIconComponent);

    function EyeIconComponent() {
      _classCallCheck(this, EyeIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(EyeIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$g(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgEye, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return EyeIconComponent;
  }(React.PureComponent);

  var EyeIcon = withStyles(EyeIconComponent);

  var getStyles$h = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      stroke: theme.stepper.background,
      width: '60px',
      height: '60px'
    };
  };

  function _extends$f() {
    _extends$f = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$f.apply(this, arguments);
  }

  var _ref$f =
  /*#__PURE__*/
  React__default.createElement("g", {
    fillRule: "evenodd"
  },
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M15 45V15h30v30H15zm14-9.334H17V43h12v-7.334zm14 0H31V43h12v-7.334zm0-9.333H30.999L31 33.666h12v-7.333zm-14.001 0h-12L17 33.666h12l-.001-7.333zM43 17H30.999v7.333H43V17zm-14.001 0h-12v7.333h12V17z",
    stroke: "none"
  }),
  /*#__PURE__*/
  React__default.createElement("circle", {
    cx: 43,
    cy: 40,
    r: 5,
    strokeWidth: 10,
    fill: "none"
  }),
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M43.42 41.872c-1.173-.03-1.864-.746-1.84-1.92.024-1.183.774-1.763 1.933-1.87 1.147.163 1.87.778 1.836 1.959-.033 1.17-.756 1.86-1.93 1.83m7.081-.6v-2.548c-2.414-.738-2.412-.737-1.336-2.595.044-.076.006-.2.006-.138l-1.53-1.873c-2.153 1.275-2.153 1.275-2.965-1.06-.39-.02-.807-.06-1.223-.057-.412.002-.824.046-1.206.07-.65 2.143-.65 2.143-2.94 1.185-.29.27-.611.545-.9.849-.281.294-.53.618-.769.903 1.223 1.97 1.223 1.97-1.137 2.74v2.434l2.28.644-1.169 2.149 1.705 1.822c2.379-1.249 2.379-1.249 2.87 1.204h2.559c.576-2.424.576-2.424 2.865-1.215l1.684-1.736c-1.227-2.314-1.227-2.314 1.206-2.779",
    stroke: "none"
  }));

  var SvgResult = function SvgResult(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$f({
        viewBox: "15 15 35.5 32",
        fill: "#fff",
        stroke: "#000"
      }, props), _ref$f)
    );
  };

  var ResultIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ResultIconComponent, _PureComponent);

    var _super = _createSuper(ResultIconComponent);

    function ResultIconComponent() {
      _classCallCheck(this, ResultIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(ResultIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$h(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgResult, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return ResultIconComponent;
  }(React.PureComponent);

  var ResultIcon = withStyles(ResultIconComponent);

  var getStyles$i = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      stroke: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  function _extends$g() {
    _extends$g = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$g.apply(this, arguments);
  }

  var _ref$g =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M13 31h8v13h-8zm13-8h8v21h-8zm13-7h9v28h-9z",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 2
  });

  var SvgView = function SvgView(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$g({
        viewBox: "0 0 60 60"
      }, props), _ref$g)
    );
  };

  var ViewIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ViewIconComponent, _PureComponent);

    var _super = _createSuper(ViewIconComponent);

    function ViewIconComponent() {
      _classCallCheck(this, ViewIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(ViewIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$i(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgView, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return ViewIconComponent;
  }(React.PureComponent);

  var ViewIcon = withStyles(ViewIconComponent);

  var getStyles$j = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      stroke: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  function _extends$h() {
    _extends$h = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$h.apply(this, arguments);
  }

  var _ref$h =
  /*#__PURE__*/
  React__default.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    d: "M42.586 16H17.414L26 24.586V44h8V24.586L42.586 16z"
  });

  var SvgFilter = function SvgFilter(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$h({
        viewBox: "17.414 16 25.172 28",
        stroke: "#FFF"
      }, props), _ref$h)
    );
  };

  var FilterIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(FilterIconComponent, _PureComponent);

    var _super = _createSuper(FilterIconComponent);

    function FilterIconComponent() {
      _classCallCheck(this, FilterIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(FilterIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$j(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgFilter, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return FilterIconComponent;
  }(React.PureComponent);

  var FilterIcon = withStyles(FilterIconComponent);

  var getStyles$k = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  function _extends$i() {
    _extends$i = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$i.apply(this, arguments);
  }

  var _ref$i =
  /*#__PURE__*/
  React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M15 45V15h30v30H15zm9-9.334h-7V43h7v-7.334zm19 0H26V43h17v-7.334zm0-9.333H25.999L26 33.666h17v-7.333zm-19.001 0h-7L17 33.666h7l-.001-7.333zM43 17H25.999v7.333H43V17zm-19.001 0h-7v7.333h7V17z"
  });

  var SvgField = function SvgField(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$i({
        viewBox: "15 15 30 30"
      }, props), _ref$i)
    );
  };

  var FieldIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(FieldIconComponent, _PureComponent);

    var _super = _createSuper(FieldIconComponent);

    function FieldIconComponent() {
      _classCallCheck(this, FieldIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(FieldIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$k(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgField, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return FieldIconComponent;
  }(React.PureComponent);

  var FieldIcon = withStyles(FieldIconComponent);

  function _extends$j() {
    _extends$j = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$j.apply(this, arguments);
  }

  var _ref$j =
  /*#__PURE__*/
  React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1.8,
    transform: "rotate(-45 47.142 -.314)"
  },
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M0 0h23.938L29.7 4.5v8.1l-5.762 4.5H0z"
  }),
  /*#__PURE__*/
  React__default.createElement("rect", {
    width: 6.3,
    height: 6.3,
    x: 17.1,
    y: 5.4,
    rx: 3.15
  }));

  var SvgTag = function SvgTag(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$j({
        viewBox: "14.03 12.241 33.093 33.093"
      }, props), _ref$j)
    );
  };

  var getStyles$l = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      stroke: theme.icon.fill,
      width: '30px',
      height: '30px'
    };
  };

  var TagIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(TagIconComponent, _PureComponent);

    var _super = _createSuper(TagIconComponent);

    function TagIconComponent() {
      _classCallCheck(this, TagIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(TagIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$l(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgTag, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return TagIconComponent;
  }(React.PureComponent);

  var TagIcon = withStyles(TagIconComponent);

  function _extends$k() {
    _extends$k = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$k.apply(this, arguments);
  }

  var _ref$k =
  /*#__PURE__*/
  React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.117 18L9 12h12z"
  });

  var SvgCaret = function SvgCaret(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$k({
        viewBox: "0 0 30 30"
      }, props), _ref$k)
    );
  };

  var getStyles$m = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '30px',
      height: '30px'
    };
  };

  var CaretIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CaretIconComponent, _PureComponent);

    var _super = _createSuper(CaretIconComponent);

    function CaretIconComponent() {
      _classCallCheck(this, CaretIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(CaretIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$m(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgCaret, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return CaretIconComponent;
  }(React.PureComponent);

  var CaretIcon = withStyles(CaretIconComponent);

  function _extends$l() {
    _extends$l = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$l.apply(this, arguments);
  }

  var _ref$l =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M503.401 228.884l-43.253-39.411V58.79c0-8.315-6.741-15.057-15.057-15.057H340.976c-8.315 0-15.057 6.741-15.057 15.057v8.374l-52.236-47.597c-10.083-9.189-25.288-9.188-35.367-.001L8.598 228.885c-8.076 7.36-10.745 18.7-6.799 28.889 3.947 10.189 13.557 16.772 24.484 16.772h36.689v209.721c0 8.315 6.741 15.057 15.057 15.057h125.913c8.315 0 15.057-6.741 15.057-15.057V356.931H293v127.337c0 8.315 6.741 15.057 15.057 15.057h125.908c8.315 0 15.057-6.741 15.056-15.057V274.547h36.697c10.926 0 20.537-6.584 24.484-16.772 3.945-10.19 1.277-21.53-6.801-28.891zm-69.436 15.549c-8.315 0-15.057 6.741-15.057 15.057v209.721h-95.793V341.874c0-8.315-6.742-15.057-15.057-15.057H203.942c-8.315 0-15.057 6.741-15.057 15.057v127.337h-95.8V259.49c0-8.315-6.741-15.057-15.057-15.057H36.245l219.756-200.24 74.836 68.191a15.061 15.061 0 0016.224 2.644 15.06 15.06 0 008.973-13.774V73.847h74.002v122.276c0 4.237 1.784 8.276 4.916 11.13l40.803 37.18h-41.79z"
  });

  var SvgHome = function SvgHome(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$l({
        viewBox: "0 0 512 512"
      }, props), _ref$l)
    );
  };

  var getStyles$n = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '20px',
      height: '20px'
    };
  };

  var HomeIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(HomeIconComponent, _PureComponent);

    var _super = _createSuper(HomeIconComponent);

    function HomeIconComponent() {
      _classCallCheck(this, HomeIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(HomeIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$n(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgHome, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return HomeIconComponent;
  }(React.PureComponent);

  var HomeIcon = withStyles(HomeIconComponent);

  function _extends$m() {
    _extends$m = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$m.apply(this, arguments);
  }

  var _ref$m =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M416.875 114.441L405.57 80.555a31.527 31.527 0 00-29.941-21.578h-95.012V28.043C280.617 12.582 268.047 0 252.59 0h-87.008c-15.453 0-28.027 12.582-28.027 28.043v30.934H42.547a31.528 31.528 0 00-29.945 21.578L1.297 114.44a25.426 25.426 0 003.484 22.856 25.427 25.427 0 0020.578 10.539h11.817L63.184 469.44C65.117 493.305 85.367 512 109.293 512h204.863c23.922 0 44.176-18.695 46.106-42.563l26.008-321.601h6.543A25.434 25.434 0 00413.39 137.3a25.434 25.434 0 003.484-22.86zM167.555 30h83.062v28.977h-83.062zm162.804 437.02c-.68 8.402-7.796 14.98-16.203 14.98H109.293c-8.406 0-15.523-6.578-16.203-14.98L67.273 147.836h288.899zM31.793 117.836l9.27-27.79c.21-.64.808-1.07 1.484-1.07h333.082c.676 0 1.27.43 1.484 1.07l9.27 27.79zm0 0"
  });

  var _ref2$4 =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M282.516 465.957c.265.016.527.02.793.02 7.925 0 14.55-6.211 14.964-14.22L312.36 181.36c.43-8.273-5.93-15.332-14.199-15.761-8.293-.442-15.328 5.925-15.762 14.199l-14.082 270.398c-.43 8.274 5.926 15.332 14.2 15.762zm0 0M120.566 451.793c.438 7.996 7.055 14.184 14.965 14.184.274 0 .555-.008.832-.024 8.27-.45 14.61-7.52 14.16-15.793L135.77 179.762c-.45-8.274-7.52-14.614-15.793-14.16-8.27.449-14.61 7.52-14.16 15.793zm0 0M209.254 465.977c8.285 0 15-6.715 15-15V180.578c0-8.285-6.715-15-15-15s-15 6.715-15 15v270.399c0 8.285 6.715 15 15 15zm0 0"
  });

  var SvgBin = function SvgBin(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$m({
        viewBox: "-47 0 512 512"
      }, props), _ref$m, _ref2$4)
    );
  };

  var getStyles$o = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '20px',
      height: '20px'
    };
  };

  var BinIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(BinIconComponent, _PureComponent);

    var _super = _createSuper(BinIconComponent);

    function BinIconComponent() {
      _classCallCheck(this, BinIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(BinIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$o(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgBin, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return BinIconComponent;
  }(React.PureComponent);

  var BinIcon = withStyles(BinIconComponent);

  function _extends$n() {
    _extends$n = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$n.apply(this, arguments);
  }

  var _ref$n =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M980.8 521.1L783.2 718.5c-12.2 12.2-32 12.2-44.2 0-12.2-12.2-12.2-31.9 0-44.1L914.6 499 739 323.7c-12.2-12.2-12.2-31.9 0-44.1 12.2-12.2 32-12.2 44.2 0L980.8 477c12.3 12.2 12.3 31.9 0 44.1zM332.9 906.5c-9 15.7-28.9 21.1-44.5 12-15.6-9-20.9-29.1-11.9-44.8L667.1 93.5c9-15.7 28.9-21.1 44.5-12 15.6 9.1 20.9 29.1 11.9 44.8L332.9 906.5zm-71.9-188c-12.2 12.2-32 12.2-44.2 0L19.1 521.1C7 508.9 7 489.2 19.1 477l197.7-197.4c12.2-12.2 32-12.2 44.2 0 12.2 12.2 12.2 31.9 0 44.1L85.4 499 261 674.4c12.2 12.2 12.2 31.9 0 44.1z"
  });

  var SvgMetadata = function SvgMetadata(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$n({
        viewBox: "0 0 1000 1000"
      }, props), _ref$n)
    );
  };

  var getStyles$p = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '20px',
      height: '20px'
    };
  };

  var MetadataIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(MetadataIconComponent, _PureComponent);

    var _super = _createSuper(MetadataIconComponent);

    function MetadataIconComponent() {
      _classCallCheck(this, MetadataIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(MetadataIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$p(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgMetadata, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return MetadataIconComponent;
  }(React.PureComponent);

  var MetadataIcon = withStyles(MetadataIconComponent);

  function _extends$o() {
    _extends$o = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$o.apply(this, arguments);
  }

  var _ref$o =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M39.56 65.62C29.1 70.75 20.69 78.74 15.36 89c-4.1 7.59-4.51 11.89-5.13 50.24-.62 26.66 0 45.93 1.64 52.7 2.67 12.3 14.56 27.27 26.86 33.42 7.59 4.1 14.15 4.1 343.68 4.1H718.3l10.25-5.95c11.07-6.36 20.3-17.84 23.58-29.12 2.87-10.05 2.67-88.79-.41-98.63-3.08-10.46-15.79-24.81-26.86-30.14l-8.82-4.31H381.8c-328.5.2-334.25.2-342.24 4.31zm677.71 34.44c3.08 5.95 2.67 89-.41 92.07-1.84 1.85-79.15 2.46-335.27 2.46-326.86 0-332.6 0-334.86-3.9-1.23-2.46-2.05-20.92-2.05-46.14 0-35.48.41-42.45 3.28-45.11 2.87-2.87 36.09-3.28 335.06-3.28 326.25.01 332 .01 334.25 3.9zM63.14 542.17c0 230.28.41 281.13 2.67 286.67 4.1 9.84 12.92 19.28 23.79 25.63l9.43 5.54 55.98.61 55.78.62v-34.86l-54.34-.61c-45.73-.62-54.75-1.03-56.39-3.69-1.23-1.85-2.05-43.27-2.05-102.12v-98.84h112.78v-34.86H98V385.3h112.78v-34.86H98v-88.18H63.14v279.91zM274.14 302.87c-14.15 7.38-23.38 19.48-26.45 34.45-1.64 7.18-2.05 26.25-1.64 51.67.61 36.5 1.03 41.22 5.13 48.6 5.12 9.64 15.17 19.48 25.22 24.81 6.97 3.69 19.89 3.9 335.27 4.51 231.51.41 331.37-.2 338.96-1.85 14.15-2.87 26.45-12.51 33.63-26.25l5.74-10.87V381.6c0-42.65-.41-46.96-4.31-55.16-5.33-11.07-19.69-23.79-30.14-26.86-5.95-1.85-91.25-2.46-339.37-2.46H285.01l-10.87 5.75zm677.1 31.17c3.69 2.05 3.9 4.72 3.9 46.75 0 24.4-.82 45.73-1.64 47.16-1.44 2.05-69.93 2.46-335.88 2.05l-334.04-.62-.61-45.93c-.41-31.99.2-46.75 1.85-48.6 2.05-2.46 54.75-2.87 332.4-2.87 223.5.01 331.36.62 334.02 2.06zM281.73 534.99c-9.23 2.87-20.92 11.89-26.66 20.71-8.2 12.3-9.84 24.61-9.02 69.1.82 45.52 1.85 50.04 16.61 64.18 15.58 15.17-10.66 14.35 359.26 13.74l332.19-.61 8.41-4.51c10.87-5.74 21.94-18.66 25.02-29.12 3.28-10.66 3.28-90.23 0-100.89-3.08-10.46-14.15-23.38-25.02-29.12l-8.41-4.51-333.21-.4c-183.33-.21-335.89.41-339.17 1.43zm670.13 36.09c4.92 4.72 4.92 89.2 0 93.92-2.87 2.87-35.88 3.28-332.19 3.28-223.1 0-330.55-.61-333.22-2.05-3.69-2.05-3.9-4.71-3.9-48.19 0-41.63.41-46.14 3.69-47.98 2.26-1.43 112.99-2.05 333.01-2.26 296.72 0 329.74.41 332.61 3.28zM282.14 771.22c-9.64 2.46-25.02 15.99-30.96 27.07-4.1 7.58-4.51 11.89-5.13 48.8-.41 24.81.2 44.5 1.64 51.47 2.87 13.94 11.89 26.45 24.2 33.83l9.64 5.54 332.19.61c248.53.41 334.45 0 341.01-1.84 10.87-3.08 25.43-15.59 30.96-27.07 3.89-8.2 4.31-12.51 4.31-54.96 0-43.88-.21-46.34-4.92-56.19-4.72-10.66-12.92-18.87-24.61-25.22-5.95-3.28-29.12-3.49-338.55-3.9-214.69-.19-334.86.42-339.78 1.86zm670.95 36.5c1.03 1.64 2.05 23.17 2.05 47.57 0 42.04-.2 44.7-3.9 46.75-6.15 3.28-662.95 2.87-666.23-.41-1.85-1.84-2.46-15.38-2.46-48.19 0-45.73 0-45.93 4.72-47.78 2.67-1.03 140.05-1.64 334.24-1.44 290.57.42 329.94.83 331.58 3.5z"
  });

  var SvgState = function SvgState(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$o({
        viewBox: "0 0 1000 1000"
      }, props), _ref$o)
    );
  };

  var getStyles$q = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '20px',
      height: '20px'
    };
  };

  var StateIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(StateIconComponent, _PureComponent);

    var _super = _createSuper(StateIconComponent);

    function StateIconComponent() {
      _classCallCheck(this, StateIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(StateIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$q(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgState, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return StateIconComponent;
  }(React.PureComponent);

  var StateIcon = withStyles(StateIconComponent);

  function _extends$p() {
    _extends$p = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$p.apply(this, arguments);
  }

  var _ref$p =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M464 64h-48V48c0-26.51-21.49-48-48-48H48C21.49 0 0 21.49 0 48v320c0 26.51 21.49 48 48 48h16v48c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM64 112v272H48c-8.837 0-16-7.163-16-16V48c0-8.837 7.163-16 16-16h320c8.837 0 16 7.163 16 16v16H112c-26.51 0-48 21.49-48 48zm416 352c0 8.837-7.163 16-16 16H112c-8.837 0-16-7.163-16-16V112c0-8.837 7.163-16 16-16h352c8.837 0 16 7.163 16 16v352z"
  });

  var SvgCopy = function SvgCopy(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$p({
        viewBox: "0 0 512 512"
      }, props), _ref$p)
    );
  };

  var getStyles$r = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '20px',
      height: '20px'
    };
  };

  var CopyIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CopyIconComponent, _PureComponent);

    var _super = _createSuper(CopyIconComponent);

    function CopyIconComponent() {
      _classCallCheck(this, CopyIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(CopyIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$r(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgCopy, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return CopyIconComponent;
  }(React.PureComponent);

  var CopyIcon = withStyles(CopyIconComponent);

  var getStyles$s = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      stroke: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  function _extends$q() {
    _extends$q = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$q.apply(this, arguments);
  }

  var _ref$q =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M500 10C229.4 10 10 229.4 10 500s219.4 490 490 490 490-219.4 490-490S770.6 10 500 10zm7.3 857.5c-203.1 0-367.5-164.4-367.5-367.5s164.4-367.5 367.5-367.5c99.1 0 182.2 36.2 246.1 96.1l-99.7 96.1c-27.4-26.2-75-56.7-146.4-56.7-125.6 0-227.8 103.9-227.8 232s102.4 232 227.8 232c145.5 0 200-104.5 208.4-158.5H507.3V447.6h347c3.1 18.4 5.7 36.8 5.7 60.9.2 209.9-140.5 359-352.7 359z"
  });

  var SvgGoogleIcon = function SvgGoogleIcon(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$q({
        viewBox: "0 0 1000 1000"
      }, props), _ref$q)
    );
  };

  var GoogleSpreadsheetIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(GoogleSpreadsheetIconComponent, _PureComponent);

    var _super = _createSuper(GoogleSpreadsheetIconComponent);

    function GoogleSpreadsheetIconComponent() {
      _classCallCheck(this, GoogleSpreadsheetIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(GoogleSpreadsheetIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$s(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgGoogleIcon, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return GoogleSpreadsheetIconComponent;
  }(React.PureComponent);

  var GoogleSpreadsheetIcon = withStyles(GoogleSpreadsheetIconComponent);

  var getStyles$t = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      stroke: theme.icon.fill,
      width: '60px',
      height: '60px'
    };
  };

  function _extends$r() {
    _extends$r = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$r.apply(this, arguments);
  }

  var _ref$r =
  /*#__PURE__*/
  React__default.createElement("path", {
    d: "M42.744 26.42c-.015 0-.03.003-.046.003.05-.39.083-.785.083-1.19 0-5.313-4.308-9.618-9.62-9.618-4.138 0-7.657 2.62-9.015 6.287a4.756 4.756 0 00-8.12 3.358c0 .068.005.133.009.198C13.134 26.262 11 28.912 11 32.07a6.865 6.865 0 006.865 6.862h24.879A6.253 6.253 0 0049 32.676a6.255 6.255 0 00-6.256-6.256z"
  });

  var SvgApiIcon = function SvgApiIcon(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$r({
        viewBox: "0 0 60 60"
      }, props), _ref$r)
    );
  };

  var ApiIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ApiIconComponent, _PureComponent);

    var _super = _createSuper(ApiIconComponent);

    function ApiIconComponent() {
      _classCallCheck(this, ApiIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(ApiIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$t(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgApiIcon, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return ApiIconComponent;
  }(React.PureComponent);

  var ApiIcon = withStyles(ApiIconComponent);

  function _extends$s() {
    _extends$s = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$s.apply(this, arguments);
  }

  var _ref$s =
  /*#__PURE__*/
  React__default.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  },
  /*#__PURE__*/
  React__default.createElement("circle", {
    cx: 4,
    cy: 10,
    r: 2,
    transform: "rotate(-90 4 10)"
  }),
  /*#__PURE__*/
  React__default.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2,
    transform: "rotate(-90 10 10)"
  }),
  /*#__PURE__*/
  React__default.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 2,
    transform: "rotate(-90 16 10)"
  }));

  var SvgThreeDots = function SvgThreeDots(props) {
    return (
      /*#__PURE__*/
      React__default.createElement("svg", _extends$s({
        width: 20,
        height: 20,
        fill: "none"
      }, props), _ref$s)
    );
  };

  var getStyles$u = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      fill: theme.icon.fill,
      width: '20px',
      height: '20px'
    };
  };

  var ThreeDotsIconComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ThreeDotsIconComponent, _PureComponent);

    var _super = _createSuper(ThreeDotsIconComponent);

    function ThreeDotsIconComponent() {
      _classCallCheck(this, ThreeDotsIconComponent);

      return _super.apply(this, arguments);
    }

    _createClass(ThreeDotsIconComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme"]);

        var containerStyles = getStyles$u(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(SvgThreeDots, Object.assign({}, restProps, {
            style: styles
          }))
        );
      }
    }]);

    return ThreeDotsIconComponent;
  }(React.PureComponent);

  var ThreeDotsIcon = withStyles(ThreeDotsIconComponent);
  var Icons = {
    ResultIcon: ResultIcon,
    ViewIcon: ViewIcon,
    FilterIcon: FilterIcon,
    FieldIcon: FieldIcon,
    ArrowLeftIcon: ArrowLeftIcon,
    ArrowRightIcon: ArrowRightIcon,
    CheckboxOffIcon: CheckboxOffIcon,
    CheckboxOnIcon: CheckboxOnIcon,
    CloseIcon: CloseIcon,
    CsvIcon: CsvIcon,
    EditIcon: EditIcon,
    ExitIcon: ExitIcon,
    IntersectIcon: IntersectIcon,
    MenuIcon: MenuIcon,
    MinusIcon: MinusIcon,
    PlusIcon: PlusIcon,
    UserIcon: UserIcon,
    UploadIcon: UploadIcon,
    EyeIcon: EyeIcon,
    TagIcon: TagIcon,
    CaretIcon: CaretIcon,
    HomeIcon: HomeIcon,
    BinIcon: BinIcon,
    MetadataIcon: MetadataIcon,
    StateIcon: StateIcon,
    CopyIcon: CopyIcon,
    GoogleSpreadsheetIcon: GoogleSpreadsheetIcon,
    ApiIcon: ApiIcon,
    ThreeDotsIcon: ThreeDotsIcon
  };

  var Accordion =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Accordion, _PureComponent);

    var _super = _createSuper(Accordion);

    function Accordion() {
      var _this;

      _classCallCheck(this, Accordion);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        accordionsState: {},
        isAnyOpen: false
      };
      _this.getIsAnyOpen = pipe(pickBy(equals(true)), complement(isEmpty));

      _this.toggleOpenAccordion = function () {
        var isAnyOpen = _this.getIsAnyOpen(_this.state.accordionsState);

        var accordionsState = map$1(function () {
          return !isAnyOpen;
        })(_this.state.accordionsState);

        _this.setState({
          accordionsState: accordionsState,
          isAnyOpen: !isAnyOpen
        });
      };

      _this.setAccordionState = function (id, value) {
        var accordionsState = _objectSpread2({}, _this.state.accordionsState);

        accordionsState[id] = value;

        var isAnyOpen = _this.getIsAnyOpen(accordionsState);

        _this.setState({
          accordionsState: accordionsState,
          isAnyOpen: isAnyOpen
        });
      };

      return _this;
    }

    _createClass(Accordion, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var temporaryAccordionState = {};
        this.props.children.forEach(function (_ref) {
          var props = _ref.props;
          temporaryAccordionState[props.id] = false;
        });
        this.setState({
          accordionsState: temporaryAccordionState,
          isAnyOpen: false
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.children.length !== this.props.children.length) {
          var newIds = this.props.children.map(function (_ref2) {
            var props = _ref2.props;
            return props.id;
          });
          var accordionsState = pipe(pickAll(newIds), map$1(ifElse(isNil, always(this.props.newOpen), identity)))(this.state.accordionsState);
          var isAnyOpen = this.getIsAnyOpen(accordionsState);
          this.setState({
            accordionsState: accordionsState,
            isAnyOpen: isAnyOpen,
            register: false
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            _this$props$arrowIcon = _this$props.arrowIcon,
            arrowIcon = _this$props$arrowIcon === void 0 ? null : _this$props$arrowIcon,
            customIconStyles = _this$props.customIconStyles,
            collapseCopy = _this$props.collapseCopy,
            expandCopy = _this$props.expandCopy,
            customExpandButtonStyles = _this$props.customExpandButtonStyles,
            rest = _objectWithoutProperties(_this$props, ["children", "arrowIcon", "customIconStyles", "collapseCopy", "expandCopy", "customExpandButtonStyles"]);

        var _this$state = this.state,
            accordionsState = _this$state.accordionsState,
            isAnyOpen = _this$state.isAnyOpen;

        var _getStyles = getStyles$1(),
            iconStyles = _getStyles.iconStyles,
            expandButtonStyles = _getStyles.expandButtonStyles;

        var icon = arrowIcon ||
        /*#__PURE__*/
        React__default.createElement(CaretIcon, {
          customStyles: _objectSpread2(_objectSpread2({}, iconStyles), customIconStyles)
        });

        var context = _objectSpread2({
          icon: icon,
          accordionsState: accordionsState,
          setAccordionState: this.setAccordionState
        }, rest);

        return (
          /*#__PURE__*/
          React__default.createElement(React.Fragment, null, collapseCopy && expandCopy && !!children ?
          /*#__PURE__*/
          React__default.createElement("div", {
            style: _objectSpread2(_objectSpread2({}, expandButtonStyles), customExpandButtonStyles),
            onClick: this.toggleOpenAccordion
          }, isAnyOpen ? collapseCopy : expandCopy) : null,
          /*#__PURE__*/
          React__default.createElement(AccordionContext.Provider, {
            value: context
          }, children), ' ')
        );
      }
    }]);

    return Accordion;
  }(React.PureComponent);

  Accordion.defaultProps = {
    customPanelStyles: {},
    customHeaderStyles: {},
    customDetailsStyles: {},
    newOpen: false
  };

  var getStyles$v = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      containerStyles: {
        borderTop: "2px solid ".concat(theme.accordion.border),
        width: '100%',
        position: 'relative'
      }
    };
  };

  var AccordionPanelContext = React.createContext({});

  var AccordionPanelComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(AccordionPanelComponent, _PureComponent);

    var _super = _createSuper(AccordionPanelComponent);

    function AccordionPanelComponent() {
      _classCallCheck(this, AccordionPanelComponent);

      return _super.apply(this, arguments);
    }

    _createClass(AccordionPanelComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            theme = _this$props.theme,
            id = _this$props.id;

        var _getStyles = getStyles$v(theme),
            containerStyles = _getStyles.containerStyles;

        return (
          /*#__PURE__*/
          React__default.createElement(AccordionContext.Consumer, null, function (_ref) {
            var customPanelStyles = _ref.customPanelStyles,
                _ref$accordionsState = _ref.accordionsState,
                accordionsState = _ref$accordionsState === void 0 ? {} : _ref$accordionsState,
                setAccordionState = _ref.setAccordionState,
                temporaryAccordionState = _ref.temporaryAccordionState,
                rest = _objectWithoutProperties(_ref, ["customPanelStyles", "accordionsState", "setAccordionState", "temporaryAccordionState"]);

            return (
              /*#__PURE__*/
              React__default.createElement(AccordionPanelContext.Provider, {
                value: _objectSpread2(_objectSpread2({}, rest), {}, {
                  open: accordionsState[id],
                  togglePanel: function togglePanel() {
                    return setAccordionState(id, !accordionsState[id]);
                  }
                })
              },
              /*#__PURE__*/
              React__default.createElement("div", {
                style: _objectSpread2(_objectSpread2({}, containerStyles), customPanelStyles)
              }, children))
            );
          })
        );
      }
    }]);

    return AccordionPanelComponent;
  }(React.PureComponent);

  var AccordionPanel = withStyles(AccordionPanelComponent);
  var TIMING_FUNCTION = 'linear';
  var ANIMATION_DURATION = 200;

  var getStyles$w = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      containerStyles: {
        transition: "height ".concat(ANIMATION_DURATION, "ms ").concat(TIMING_FUNCTION, ", overflow 0s ").concat(TIMING_FUNCTION, " ").concat(ANIMATION_DURATION, "ms"),
        backgroundColor: theme.accordion.background
      }
    };
  };

  var AccordionDetailsContentComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(AccordionDetailsContentComponent, _PureComponent);

    var _super = _createSuper(AccordionDetailsContentComponent);

    function AccordionDetailsContentComponent() {
      var _this;

      _classCallCheck(this, AccordionDetailsContentComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        height: 0,
        overflow: 'hidden',
        open: false
      };

      _this.delayOverflow = function () {
        return setTimeout(function () {
          return _this.setState({
            overflow: 'inherit',
            height: 'auto'
          });
        }, ANIMATION_DURATION);
      };

      _this.innerRef = React.createRef();
      return _this;
    }

    _createClass(AccordionDetailsContentComponent, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(_ref) {
        var _this2 = this;

        var _ref$open = _ref.open,
            prevOpen = _ref$open === void 0 ? false : _ref$open;
        var open = this.props.open;

        if (prevOpen !== open) {
          var height = this.innerRef.current && this.innerRef.current.offsetHeight || 0;
          this.setState({
            height: height,
            overflow: 'hidden'
          });

          if (open) {
            this.delayOverflow();
            return;
          }

          setTimeout(function () {
            _this2.setState({
              height: 0,
              overflow: 'hidden'
            });

            setTimeout(function () {
              _this2.setState({
                open: false
              });
            }, ANIMATION_DURATION);
          }, ANIMATION_DURATION / 2);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            customDetailsStyles = _this$props.customDetailsStyles,
            theme = _this$props.theme;
        var _this$state = this.state,
            overflow = _this$state.overflow,
            height = _this$state.height,
            open = _this$state.open;

        var _getStyles = getStyles$w(theme),
            containerStyles = _getStyles.containerStyles;

        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: _objectSpread2(_objectSpread2(_objectSpread2({}, containerStyles), customDetailsStyles), {}, {
              overflow: overflow,
              height: height
            })
          },
          /*#__PURE__*/
          React__default.createElement("div", {
            ref: this.innerRef
          }, open ? children : null))
        );
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref2) {
        var open = _ref2.open;

        if (open) {
          return {
            open: open
          };
        }

        return null;
      }
    }]);

    return AccordionDetailsContentComponent;
  }(React.PureComponent);

  AccordionDetailsContentComponent.defaultProps = {
    customDetailsStyles: {},
    open: false
  };
  var AccordionDetailsContent = withStyles(AccordionDetailsContentComponent);

  var AccordionDetails =
  /*#__PURE__*/
  function (_PureComponent2) {
    _inherits(AccordionDetails, _PureComponent2);

    var _super2 = _createSuper(AccordionDetails);

    function AccordionDetails() {
      _classCallCheck(this, AccordionDetails);

      return _super2.apply(this, arguments);
    }

    _createClass(AccordionDetails, [{
      key: "render",
      value: function render() {
        var children = this.props.children;
        return (
          /*#__PURE__*/
          React__default.createElement(AccordionPanelContext.Consumer, null, function (props) {
            return (
              /*#__PURE__*/
              React__default.createElement(AccordionDetailsContent, props, children)
            );
          })
        );
      }
    }]);

    return AccordionDetails;
  }(React.PureComponent);

  var getStyles$x = function getStyles(_ref) {
    var open = _ref.open,
        _ref$theme = _ref.theme,
        theme = _ref$theme === void 0 ? defaultTheme : _ref$theme;
    return {
      containerStyles: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: 60,
        position: 'relative',
        paddingRight: 40,
        backgroundColor: theme.accordion.background
      },
      iconContainerStyles: {
        cursor: 'pointer',
        transition: 'transform 200ms ease-in-out',
        transformOrigin: 'center center',
        fontSize: 0,
        transform: "rotate(".concat(open ? 180 : 0, "deg)"),
        position: 'absolute',
        right: 0,
        top: 9
      }
    };
  };

  var AccordionHeaderComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(AccordionHeaderComponent, _PureComponent);

    var _super = _createSuper(AccordionHeaderComponent);

    function AccordionHeaderComponent() {
      _classCallCheck(this, AccordionHeaderComponent);

      return _super.apply(this, arguments);
    }

    _createClass(AccordionHeaderComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            theme = _this$props.theme;
        return (
          /*#__PURE__*/
          React__default.createElement(AccordionPanelContext.Consumer, null, function (_ref) {
            var icon = _ref.icon,
                togglePanel = _ref.togglePanel,
                open = _ref.open,
                customHeaderStyles = _ref.customHeaderStyles;

            var _getStyles = getStyles$x({
              open: open,
              theme: theme
            }),
                containerStyles = _getStyles.containerStyles,
                iconContainerStyles = _getStyles.iconContainerStyles;

            return (
              /*#__PURE__*/
              React__default.createElement("div", {
                style: _objectSpread2(_objectSpread2({}, containerStyles), customHeaderStyles)
              }, children,
              /*#__PURE__*/
              React__default.createElement("div", {
                onClick: togglePanel,
                style: iconContainerStyles
              }, icon))
            );
          })
        );
      }
    }]);

    return AccordionHeaderComponent;
  }(React.PureComponent);

  var AccordionHeader = withStyles(AccordionHeaderComponent);

  var _sizes;

  var sizes = (_sizes = {}, _defineProperty(_sizes, BUTTON_SIZES.BIG, {
    borderRadius: '30px',
    padding: '0',
    minHeight: '48px',
    fontSize: '20px'
  }), _defineProperty(_sizes, BUTTON_SIZES.MEDIUM, {
    borderRadius: '4px',
    padding: '0 8px 0 6px',
    minHeight: '32px',
    fontSize: '14px'
  }), _defineProperty(_sizes, BUTTON_SIZES.SMALL, {
    borderRadius: '30px',
    padding: '0 16px',
    minHeight: '30px',
    fontSize: '14px'
  }), _sizes);

  var getStyles$y = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    var buttonType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BUTTON;
    var disabled = arguments.length > 2 ? arguments[2] : undefined;
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : BUTTON_SIZES.BIG;
    var usesNewStyling = arguments.length > 4 ? arguments[4] : undefined;
    return {
      containerStyles: {
        border: 'none',
        borderRadius: sizes[size].borderRadius,
        backgroundColor: usesNewStyling ? theme.textArea.background : theme[buttonType].background,
        fill: theme.icon.fill,
        color: theme[buttonType].text,
        padding: sizes[size].padding,
        margin: '0',
        outline: 'none',
        cursor: disabled ? 'default' : 'pointer',
        minHeight: sizes[size].minHeight,
        fontSize: sizes[size].fontSize,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'background 0.25s ease-in-out, color 0.25s ease-in-out'
      }
    };
  };

  var ButtonComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ButtonComponent, _PureComponent);

    var _super = _createSuper(ButtonComponent);

    function ButtonComponent() {
      _classCallCheck(this, ButtonComponent);

      return _super.apply(this, arguments);
    }

    _createClass(ButtonComponent, [{
      key: "getButtonType",
      value: function getButtonType(disabled, inverse) {
        if (disabled) {
          return BUTTON_DISABLED;
        }

        return inverse ? INVERSE_BUTTON : BUTTON;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            inverse = _this$props.inverse,
            disabled = _this$props.disabled,
            size = _this$props.size,
            restProps = _objectWithoutProperties(_this$props, ["children", "customStyles", "theme", "inverse", "disabled", "size"]);

        var buttonType = this.getButtonType(disabled, inverse);

        var _getStyles = getStyles$y(theme, buttonType, disabled, size),
            containerStyles = _getStyles.containerStyles;

        var style = _objectSpread2(_objectSpread2({}, containerStyles), this.props.customStyles);

        var buttonProps = _objectSpread2({
          disabled: disabled
        }, restProps);

        var filteredProps = filterAllowedAttributes('button', buttonProps);
        return (
          /*#__PURE__*/
          React__default.createElement("button", Object.assign({
            style: style
          }, filteredProps), children)
        );
      }
    }]);

    return ButtonComponent;
  }(React.PureComponent);

  ButtonComponent.defaultProps = {
    customStyles: {},
    inverse: false,
    disabled: false,
    size: BUTTON_SIZES.BIG
  };
  var Button = withStyles(ButtonComponent);

  var getStyles$z = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      containerStyles: {
        color: theme.header.text,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '100%',
        paddingBottom: '18px'
      },
      buttonStyles: {
        backgroundColor: 'transparent',
        position: 'absolute',
        top: 6,
        right: 0
      }
    };
  };

  var HeaderComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(HeaderComponent, _PureComponent);

    var _super = _createSuper(HeaderComponent);

    function HeaderComponent() {
      var _this;

      _classCallCheck(this, HeaderComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.renderIcon = function (buttonStyles) {
        var _this$props = _this.props,
            iconComponent = _this$props.iconComponent,
            customButtonStyles = _this$props.customButtonStyles,
            buttonProps = _this$props.buttonProps;

        var styles = _objectSpread2(_objectSpread2({}, buttonStyles), customButtonStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(Button, Object.assign({
            customStyles: styles
          }, buttonProps), iconComponent)
        );
      };

      return _this;
    }

    _createClass(HeaderComponent, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            theme = _this$props2.theme,
            customStyles = _this$props2.customStyles;

        var _getStyles = getStyles$z(theme),
            buttonStyles = _getStyles.buttonStyles,
            containerStyles = _getStyles.containerStyles;

        var style = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: style
          },
          /*#__PURE__*/
          React__default.createElement("div", null, this.props.children), this.renderIcon(buttonStyles))
        );
      }
    }]);

    return HeaderComponent;
  }(React.PureComponent);

  HeaderComponent.defaultProps = {
    iconComponent:
    /*#__PURE__*/
    React__default.createElement(MenuIcon, null),
    customStyles: {},
    customButtonStyles: {},
    buttonProps: {}
  };
  var Header = withStyles(HeaderComponent);

  var getStyles$A = function getStyles(_ref) {
    var _ref$theme = _ref.theme,
        theme = _ref$theme === void 0 ? defaultTheme : _ref$theme,
        isDesktop = _ref.isDesktop;
    return {
      containerStyles: {
        backgroundColor: theme.menu.background,
        color: theme.menu.text,
        position: 'fixed',
        top: 0,
        bottom: isDesktop ? 'auto' : 0,
        right: 0,
        width: '100%',
        maxWidth: '360px',
        padding: '18px 20px 27px',
        transition: 'transform 400ms cubic-bezier(0.86, 0, 0.07, 1), visibility 0s linear 400ms',
        textAlign: 'left'
      },
      closeButtonStyles: {
        position: 'absolute',
        top: '6px',
        right: 0
      },
      showStyles: {
        visibility: 1
      },
      hideStyles: {
        visibility: 0,
        transform: 'translateX(100%)'
      }
    };
  };

  var MenuComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(MenuComponent, _PureComponent);

    var _super = _createSuper(MenuComponent);

    function MenuComponent() {
      var _this;

      _classCallCheck(this, MenuComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.renderCloseButton = function (closeButtonStyles) {
        var _this$props$closeButt = _this.props.closeButtonProps,
            customStyles = _this$props$closeButt.customStyles,
            iconStyles = _this$props$closeButt.iconStyles,
            restProps = _objectWithoutProperties(_this$props$closeButt, ["customStyles", "iconStyles"]);

        var buttonStyles = _objectSpread2(_objectSpread2({}, closeButtonStyles), customStyles);

        return (
          /*#__PURE__*/
          React__default.createElement(Button, Object.assign({}, restProps, {
            onClick: _this.props.onClose,
            customStyles: buttonStyles
          }),
          /*#__PURE__*/
          React__default.createElement(CloseIcon, {
            customStyles: iconStyles
          }))
        );
      };

      return _this;
    }

    _createClass(MenuComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            children = _this$props.children,
            theme = _this$props.theme,
            open = _this$props.open,
            isDesktop = _this$props.isDesktop,
            id = _this$props.id;

        var _getStyles = getStyles$A({
          theme: theme,
          isDesktop: isDesktop
        }),
            closeButtonStyles = _getStyles.closeButtonStyles,
            containerStyles = _getStyles.containerStyles,
            hideStyles = _getStyles.hideStyles,
            showStyles = _getStyles.showStyles;

        var animationStyles = open ? showStyles : hideStyles;

        var styles = _objectSpread2(_objectSpread2(_objectSpread2({}, containerStyles), customStyles), animationStyles);

        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: styles,
            id: id
          }, children, this.renderCloseButton(closeButtonStyles))
        );
      }
    }]);

    return MenuComponent;
  }(React.PureComponent);

  MenuComponent.defaultProps = {
    id: '',
    customStyles: {},
    open: false,
    isDesktop: false,
    onClose: function onClose() {},
    closeButtonProps: {
      customStyles: {},
      iconStyles: {}
    }
  };
  var Menu = withStyles(MenuComponent);
  var headerStyles = {
    lineHeight: 1.25,
    letterSpacing: '-0.12px',
    margin: 0
  };

  var H1 =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(H1, _PureComponent);

    var _super = _createSuper(H1);

    function H1() {
      _classCallCheck(this, H1);

      return _super.apply(this, arguments);
    }

    _createClass(H1, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$customSty = _this$props.customStyles,
            customStyles = _this$props$customSty === void 0 ? {} : _this$props$customSty,
            _this$props$theme = _this$props.theme,
            theme = _this$props$theme === void 0 ? light : _this$props$theme,
            children = _this$props.children,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme", "children"]);

        var style = _objectSpread2(_objectSpread2(_objectSpread2({}, headerStyles), theme.typography.h1), customStyles);

        var props = _objectSpread2({
          style: style
        }, restProps);

        var filteredProps = filterAllowedAttributes('h1', props);
        return (
          /*#__PURE__*/
          React__default.createElement("h1", filteredProps, children)
        );
      }
    }]);

    return H1;
  }(React.PureComponent);

  var headerStyles$1 = {
    margin: 0
  };

  var H2 =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(H2, _PureComponent);

    var _super = _createSuper(H2);

    function H2() {
      _classCallCheck(this, H2);

      return _super.apply(this, arguments);
    }

    _createClass(H2, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$customSty = _this$props.customStyles,
            customStyles = _this$props$customSty === void 0 ? {} : _this$props$customSty,
            _this$props$theme = _this$props.theme,
            theme = _this$props$theme === void 0 ? light : _this$props$theme,
            children = _this$props.children,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme", "children"]);

        var style = _objectSpread2(_objectSpread2(_objectSpread2({}, headerStyles$1), theme.typography.h2), customStyles);

        var props = _objectSpread2({
          style: style
        }, restProps);

        var filteredProps = filterAllowedAttributes('h2', props);
        return (
          /*#__PURE__*/
          React__default.createElement("h2", filteredProps, children)
        );
      }
    }]);

    return H2;
  }(React.PureComponent);

  var headerStyles$2 = {
    margin: 0
  };

  var H3 =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(H3, _PureComponent);

    var _super = _createSuper(H3);

    function H3() {
      _classCallCheck(this, H3);

      return _super.apply(this, arguments);
    }

    _createClass(H3, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$customSty = _this$props.customStyles,
            customStyles = _this$props$customSty === void 0 ? {} : _this$props$customSty,
            _this$props$theme = _this$props.theme,
            theme = _this$props$theme === void 0 ? light : _this$props$theme,
            children = _this$props.children,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme", "children"]);

        var style = _objectSpread2(_objectSpread2(_objectSpread2({}, headerStyles$2), theme.typography.h3), customStyles);

        var props = _objectSpread2({
          style: style
        }, restProps);

        var filteredProps = filterAllowedAttributes('h3', props);
        return (
          /*#__PURE__*/
          React__default.createElement("h3", filteredProps, children)
        );
      }
    }]);

    return H3;
  }(React.PureComponent);

  var containerStyles = {
    lineHeight: '1.33em',
    margin: 0
  };

  var P =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(P, _PureComponent);

    var _super = _createSuper(P);

    function P() {
      _classCallCheck(this, P);

      return _super.apply(this, arguments);
    }

    _createClass(P, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$customSty = _this$props.customStyles,
            customStyles = _this$props$customSty === void 0 ? {} : _this$props$customSty,
            _this$props$theme = _this$props.theme,
            theme = _this$props$theme === void 0 ? light : _this$props$theme,
            children = _this$props.children,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme", "children"]);

        var style = _objectSpread2(_objectSpread2(_objectSpread2({}, containerStyles), theme.typography.p), customStyles);

        var props = _objectSpread2({
          style: style
        }, restProps);

        var filteredProps = filterAllowedAttributes('p', props);
        return (
          /*#__PURE__*/
          React__default.createElement("p", filteredProps, children)
        );
      }
    }]);

    return P;
  }(React.PureComponent);

  var Pre =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Pre, _PureComponent);

    var _super = _createSuper(Pre);

    function Pre() {
      _classCallCheck(this, Pre);

      return _super.apply(this, arguments);
    }

    _createClass(Pre, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$customSty = _this$props.customStyles,
            customStyles = _this$props$customSty === void 0 ? {} : _this$props$customSty,
            _this$props$theme = _this$props.theme,
            theme = _this$props$theme === void 0 ? light : _this$props$theme,
            children = _this$props.children,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme", "children"]);

        var style = _objectSpread2(_objectSpread2({}, theme.typography.pre), customStyles);

        var props = _objectSpread2({
          style: style
        }, restProps);

        var filteredProps = filterAllowedAttributes('pre', props);
        return (
          /*#__PURE__*/
          React__default.createElement("pre", filteredProps, children)
        );
      }
    }]);

    return Pre;
  }(React.PureComponent);

  var Span =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Span, _PureComponent);

    var _super = _createSuper(Span);

    function Span() {
      _classCallCheck(this, Span);

      return _super.apply(this, arguments);
    }

    _createClass(Span, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$customSty = _this$props.customStyles,
            customStyles = _this$props$customSty === void 0 ? {} : _this$props$customSty,
            _this$props$theme = _this$props.theme,
            theme = _this$props$theme === void 0 ? light : _this$props$theme,
            children = _this$props.children,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme", "children"]);

        var style = _objectSpread2(_objectSpread2({}, theme.typography.span), customStyles);

        var props = _objectSpread2({
          style: style
        }, restProps);

        var filteredProps = filterAllowedAttributes('span', props);
        return (
          /*#__PURE__*/
          React__default.createElement("span", filteredProps, children)
        );
      }
    }]);

    return Span;
  }(React.PureComponent);

  var Typography = {
    H1: H1,
    H2: H2,
    H3: H3,
    P: P,
    Pre: Pre,
    Span: Span
  };
  /* eslint-disable no-undefined,no-param-reassign,no-shadow */

  /**
   * Throttle execution of a function. Especially useful for rate limiting
   * execution of handlers on events like resize and scroll.
   *
   * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
   * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
   *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
   *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
   *                                    the internal counter is reset).
   * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
   *                                    to `callback` when the throttled-function is executed.
   * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
   *                                    schedule `callback` to execute after `delay` ms.
   *
   * @returns {Function}  A new, throttled, function.
   */

  function throttle(delay, noTrailing, callback, debounceMode) {
    /*
     * After wrapper has stopped being called, this timeout ensures that
     * `callback` is executed at the proper times in `throttle` and `end`
     * debounce modes.
     */
    var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.

    var lastExec = 0; // Function to clear existing timeout

    function clearExistingTimeout() {
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
    } // Function to cancel next exec


    function cancel() {
      clearExistingTimeout();
      cancelled = true;
    } // `noTrailing` defaults to falsy.


    if (typeof noTrailing !== 'boolean') {
      debounceMode = callback;
      callback = noTrailing;
      noTrailing = undefined;
    }
    /*
     * The `wrapper` function encapsulates all of the throttling / debouncing
     * functionality and when executed will limit the rate at which `callback`
     * is executed.
     */


    function wrapper() {
      for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
        arguments_[_key] = arguments[_key];
      }

      var self = this;
      var elapsed = Date.now() - lastExec;

      if (cancelled) {
        return;
      } // Execute `callback` and update the `lastExec` timestamp.


      function exec() {
        lastExec = Date.now();
        callback.apply(self, arguments_);
      }
      /*
       * If `debounceMode` is true (at begin) this is used to clear the flag
       * to allow future `callback` executions.
       */


      function clear() {
        timeoutID = undefined;
      }

      if (debounceMode && !timeoutID) {
        /*
         * Since `wrapper` is being called for the first time and
         * `debounceMode` is true (at begin), execute `callback`.
         */
        exec();
      }

      clearExistingTimeout();

      if (debounceMode === undefined && elapsed > delay) {
        /*
         * In throttle mode, if `delay` time has been exceeded, execute
         * `callback`.
         */
        exec();
      } else if (noTrailing !== true) {
        /*
         * In trailing throttle mode, since `delay` time has not been
         * exceeded, schedule `callback` to execute `delay` ms after most
         * recent execution.
         *
         * If `debounceMode` is true (at begin), schedule `clear` to execute
         * after `delay` ms.
         *
         * If `debounceMode` is false (at end), schedule `callback` to
         * execute after `delay` ms.
         */
        timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
      }
    }

    wrapper.cancel = cancel; // Return the wrapper function.

    return wrapper;
  }
  /* eslint-disable no-undefined */

  /**
   * Debounce execution of a function. Debouncing, unlike throttling,
   * guarantees that a function is only executed a single time, either at the
   * very beginning of a series of calls, or at the very end.
   *
   * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
   * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
   *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
   *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
   * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
   *                                  to `callback` when the debounced-function is executed.
   *
   * @returns {Function} A new, debounced function.
   */


  function debounce(delay, atBegin, callback) {
    return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
  }

  var MIN_WIDTH = 60;

  var getStyles$B = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      defaultStyles: {
        border: 'none',
        outline: 'none',
        color: theme.input.text,
        fontSize: '18px',
        lineHeight: '24px',
        backgroundColor: 'transparent',
        padding: 0,
        fontFamily: 'inherit',
        fontWeight: 'inherit',
        minWidth: MIN_WIDTH,
        maxWidth: '100%',
        letterSpacing: 'normal'
      },
      hiddenStyles: {
        opacity: 0,
        visibility: 'hidden',
        position: 'fixed',
        whiteSpace: 'pre'
      }
    };
  };

  var InputComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(InputComponent, _PureComponent);

    var _super = _createSuper(InputComponent);

    function InputComponent() {
      var _this;

      _classCallCheck(this, InputComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        inputWidth: _this.props.autoWidth ? MIN_WIDTH : null,
        alternativeValue: _this.props.value,
        stateValue: _this.props.value,
        autoFocus: false
      };
      _this.spanRef = React.createRef();
      _this.inputRef = React.createRef();
      _this.handleDebounce = debounce(200, _this.props.onChange);

      _this.handleChange = function (e) {
        if (_this.props.autoWidth || _this.props.debounceValue) {
          var _e$target = e.target,
              value = _e$target.value,
              name = _e$target.name,
              id = _e$target.id;

          _this.setState({
            alternativeValue: value,
            stateValue: value
          });

          return setTimeout(function () {
            if (_this.props.autoWidth) {
              _this.setState({
                inputWidth: _this.spanRef.current.offsetWidth
              });
            }

            _this.handleDebounce({
              target: {
                value: value,
                name: name,
                id: id
              }
            });
          });
        }

        _this.props.onChange(e);
      };

      return _this;
    }

    _createClass(InputComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        if (this.props.autoWidth) {
          setTimeout(function () {
            if (_this2.spanRef.current) {
              _this2.setState({
                inputWidth: _this2.spanRef.current.offsetWidth
              });
            }
          });
        }

        if (this.props.autoFocus && this.inputRef.current) {
          this.inputRef.current.focus();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$customSty = _this$props.customStyles,
            customStyles = _this$props$customSty === void 0 ? {} : _this$props$customSty,
            _this$props$autoWidth = _this$props.autoWidth,
            autoWidth = _this$props$autoWidth === void 0 ? false : _this$props$autoWidth,
            theme = _this$props.theme,
            inputRef = _this$props.inputRef,
            onChange = _this$props.onChange,
            value = _this$props.value,
            autoFocus = _this$props.autoFocus,
            debounceValue = _this$props.debounceValue,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "autoWidth", "theme", "inputRef", "onChange", "value", "autoFocus", "debounceValue"]);

        var _this$state = this.state,
            alternativeValue = _this$state.alternativeValue,
            inputWidth = _this$state.inputWidth,
            stateValue = _this$state.stateValue;

        var _getStyles = getStyles$B(theme),
            defaultStyles = _getStyles.defaultStyles,
            hiddenStyles = _getStyles.hiddenStyles;

        var inputStyles = _objectSpread2(_objectSpread2({}, defaultStyles), customStyles);

        var filteredProps = filterAllowedAttributes('input', restProps);
        return (
          /*#__PURE__*/
          React__default.createElement(React.Fragment, null,
          /*#__PURE__*/
          React__default.createElement("input", Object.assign({
            id: restProps.name,
            style: inputWidth ? _objectSpread2(_objectSpread2({}, inputStyles), {}, {
              width: inputWidth + 20
            }) : inputStyles,
            ref: autoFocus ? this.inputRef : inputRef,
            value: autoWidth || debounceValue ? stateValue : value
          }, filteredProps, {
            onChange: this.handleChange
          })), autoWidth ?
          /*#__PURE__*/
          React__default.createElement("div", {
            style: _objectSpread2(_objectSpread2({}, inputStyles), hiddenStyles),
            ref: this.spanRef
          }, alternativeValue) : null)
        );
      }
    }]);

    return InputComponent;
  }(React.PureComponent);

  var Input = withStyles(InputComponent);

  var getStyles$C = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      border: 'none',
      outline: 'none',
      color: theme.label.text,
      fontSize: '14px',
      borderTop: "2px solid ".concat(theme.label.border),
      paddingTop: '8px',
      display: 'block',
      width: '100%'
    };
  };

  var LabelComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(LabelComponent, _PureComponent);

    var _super = _createSuper(LabelComponent);

    function LabelComponent() {
      _classCallCheck(this, LabelComponent);

      return _super.apply(this, arguments);
    }

    _createClass(LabelComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            name = _this$props.name,
            theme = _this$props.theme,
            customStyles = _this$props.customStyles,
            restProps = _objectWithoutProperties(_this$props, ["children", "name", "theme", "customStyles"]);

        var defaultStyles = getStyles$C(theme);

        var labelStyles = _objectSpread2(_objectSpread2({}, defaultStyles), customStyles);

        var filteredProps = filterAllowedAttributes('label', restProps);
        return (
          /*#__PURE__*/
          React__default.createElement("label", Object.assign({
            style: labelStyles,
            htmlFor: name
          }, filteredProps), children)
        );
      }
    }]);

    return LabelComponent;
  }(React.PureComponent);

  LabelComponent.defaultProps = {
    customStyles: {}
  };
  var Label = withStyles(LabelComponent);
  var RadioGroupContext = React__default.createContext();
  var containerStyles$1 = {
    display: 'flex',
    flexDirection: 'row'
  };

  var RadioGroup =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(RadioGroup, _PureComponent);

    var _super = _createSuper(RadioGroup);

    function RadioGroup() {
      _classCallCheck(this, RadioGroup);

      return _super.apply(this, arguments);
    }

    _createClass(RadioGroup, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            name = _this$props.name,
            children = _this$props.children,
            onChange = _this$props.onChange,
            value = _this$props.value,
            customLabelStyles = _this$props.customLabelStyles,
            customCheckedStyles = _this$props.customCheckedStyles,
            customStyles = _this$props.customStyles,
            restProps = _objectWithoutProperties(_this$props, ["name", "children", "onChange", "value", "customLabelStyles", "customCheckedStyles", "customStyles"]);

        var context = {
          name: name,
          onChange: onChange,
          value: value,
          customLabelStyles: customLabelStyles,
          customCheckedStyles: customCheckedStyles
        };

        var styles = _objectSpread2(_objectSpread2({}, containerStyles$1), customStyles);

        var filteredProps = filterAllowedAttributes('div', restProps);
        return (
          /*#__PURE__*/
          React__default.createElement("div", Object.assign({
            style: styles
          }, filteredProps),
          /*#__PURE__*/
          React__default.createElement(RadioGroupContext.Provider, {
            value: context
          }, children))
        );
      }
    }]);

    return RadioGroup;
  }(React.PureComponent);

  RadioGroup.defaultProps = {
    customStyles: {},
    customLabelStyles: {},
    customCheckedStyles: {}
  };

  var getStyles$D = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      containerStyles: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        color: theme.radioButton.text
      },
      inputStyles: {
        visibility: 'hidden',
        position: 'absolute',
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0
      },
      labelStyles: {
        cursor: 'pointer'
      }
    };
  };

  var RadioBaseComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(RadioBaseComponent, _PureComponent);

    var _super = _createSuper(RadioBaseComponent);

    function RadioBaseComponent() {
      var _this;

      _classCallCheck(this, RadioBaseComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.renderAdditionalText = function (label) {
        return label || null;
      };

      return _this;
    }

    _createClass(RadioBaseComponent, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            children = _this$props.children,
            id = _this$props.id,
            label = _this$props.label,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["children", "id", "label", "theme"]);

        var _getStyles = getStyles$D(theme),
            containerStyles = _getStyles.containerStyles,
            inputStyles = _getStyles.inputStyles,
            labelStyles = _getStyles.labelStyles;

        return (
          /*#__PURE__*/
          React__default.createElement(RadioGroupContext.Consumer, null, function (_ref) {
            var name = _ref.name,
                onChange = _ref.onChange,
                value = _ref.value,
                _ref$customLabelStyle = _ref.customLabelStyles,
                customLabelStyles = _ref$customLabelStyle === void 0 ? {} : _ref$customLabelStyle,
                _ref$customCheckedSty = _ref.customCheckedStyles,
                customCheckedStyles = _ref$customCheckedSty === void 0 ? {} : _ref$customCheckedSty;
            var checked = value === restProps.value;
            var labelCheckedStyles = checked ? customCheckedStyles : {};

            var styles = _objectSpread2(_objectSpread2(_objectSpread2({}, labelStyles), customLabelStyles), labelCheckedStyles);

            var filteredProps = filterAllowedAttributes('input', restProps);
            return (
              /*#__PURE__*/
              React__default.createElement("div", {
                style: containerStyles
              },
              /*#__PURE__*/
              React__default.createElement("input", Object.assign({
                onChange: onChange,
                value: restProps.value,
                name: name,
                defaultChecked: checked,
                "aria-hidden": true,
                type: "radio",
                id: id,
                style: inputStyles
              }, filteredProps)),
              /*#__PURE__*/
              React__default.createElement("label", {
                htmlFor: id,
                style: styles
              }, children), _this2.renderAdditionalText(label))
            );
          })
        );
      }
    }]);

    return RadioBaseComponent;
  }(React.PureComponent);

  var getRadio = function getRadio(_ref) {
    var radioButton = _ref.radioButton;
    return {
      width: '16px',
      height: '16px',
      border: "1px solid ".concat(radioButton.border),
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    };
  };

  var getCheckedRadio = function getCheckedRadio(_ref2) {
    var radioButton = _ref2.radioButton;
    return {
      width: '8px',
      height: '8px',
      backgroundColor: radioButton.active.background,
      borderRadius: '50%',
      transition: 'background 0.25s ease-in-out'
    };
  };

  var getUncheckedRadio = function getUncheckedRadio(_ref3) {
    var radioButton = _ref3.radioButton;
    return {
      width: '8px',
      height: '8px',
      backgroundColor: 'transparent',
      borderRadius: '50%',
      transition: 'background 0.25s ease-in-out'
    };
  };

  var getStyles$E = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      radioStyles: getRadio(theme),
      checkedRadioStyles: getCheckedRadio(theme),
      unCheckedRadioStyles: getUncheckedRadio(theme)
    };
  };

  var RadioStyledComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(RadioStyledComponent, _PureComponent);

    var _super = _createSuper(RadioStyledComponent);

    function RadioStyledComponent() {
      _classCallCheck(this, RadioStyledComponent);

      return _super.apply(this, arguments);
    }

    _createClass(RadioStyledComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            selectedValue = _this$props.selectedValue,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["selectedValue", "theme"]);

        var _getStyles = getStyles$E(theme),
            radioStyles = _getStyles.radioStyles,
            checkedRadioStyles = _getStyles.checkedRadioStyles,
            unCheckedRadioStyles = _getStyles.unCheckedRadioStyles;

        return (
          /*#__PURE__*/
          React__default.createElement(RadioBaseComponent, restProps,
          /*#__PURE__*/
          React__default.createElement("div", {
            style: radioStyles
          }, restProps.value === selectedValue ?
          /*#__PURE__*/
          React__default.createElement("div", {
            style: checkedRadioStyles
          }) :
          /*#__PURE__*/
          React__default.createElement("div", {
            style: unCheckedRadioStyles
          })))
        );
      }
    }]);

    return RadioStyledComponent;
  }(React.PureComponent);

  var RadioStyled = withStyles(RadioStyledComponent);

  var getStyles$F = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      defaultStyles: {
        border: 'none',
        outline: 'none',
        color: theme.textArea.text,
        background: theme.textArea.background,
        fontSize: '18px',
        lineHeight: '24px',
        resize: 'none',
        padding: '0'
      },
      shadowStyles: {
        visibility: 'hidden',
        position: 'absolute',
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0
      }
    };
  };

  var TextAreaComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(TextAreaComponent, _PureComponent);

    var _super = _createSuper(TextAreaComponent);

    _createClass(TextAreaComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.syncHeight();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
          this.syncHeight();
        }
      }
    }]);

    function TextAreaComponent(props) {
      var _this;

      _classCallCheck(this, TextAreaComponent);

      _this = _super.call(this, props);
      _this.state = {
        height: 0,
        stateValue: _this.props.value
      };
      _this.handleDebounce = debounce(200, _this.props.onChange);

      _this.handleChange = function (event) {
        _this.syncHeight();

        if (_this.props.onChange) {
          var _event$target = event.target,
              name = _event$target.name,
              id = _event$target.id,
              value = _event$target.value;

          _this.setState({
            stateValue: value
          });

          _this.handleDebounce({
            target: {
              name: name,
              id: id,
              value: value
            }
          });
        }
      };

      _this.getStyleValue = function (computedStyle, property) {
        return parseInt(computedStyle[property], 10) || 0;
      };

      _this.syncHeight = function () {
        var input = _this.textAreaRef.current;
        var inputShallow = _this.shadowRef.current;

        if (!input || !inputShallow) {
          return;
        }

        var computedStyle = window.getComputedStyle(input);
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || _this.props.placeholder || 'x';
        var boxSizing = computedStyle['box-sizing'];

        var padding = _this.getStyleValue(computedStyle, 'padding-bottom') + _this.getStyleValue(computedStyle, 'padding-top');

        var border = _this.getStyleValue(computedStyle, 'border-bottom-width') + _this.getStyleValue(computedStyle, 'border-top-width');

        var innerHeight = inputShallow.scrollHeight - padding;
        var height = innerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        inputShallow.value = 'x';

        _this.setState({
          height: height
        });
      };

      _this.textAreaRef = React.createRef();
      _this.shadowRef = React.createRef();
      return _this;
    }

    _createClass(TextAreaComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            name = _this$props.name,
            theme = _this$props.theme,
            value = _this$props.value,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "name", "theme", "value"]);

        var _this$state = this.state,
            height = _this$state.height,
            stateValue = _this$state.stateValue;

        var _getStyles = getStyles$F(theme),
            defaultStyles = _getStyles.defaultStyles,
            shadowStyles = _getStyles.shadowStyles;

        var styles = _objectSpread2(_objectSpread2({}, defaultStyles), customStyles);

        var filteredProps = filterAllowedAttributes('textarea', restProps);
        return (
          /*#__PURE__*/
          React__default.createElement(React.Fragment, null,
          /*#__PURE__*/
          React__default.createElement("textarea", Object.assign({
            id: name,
            style: _objectSpread2({
              height: height
            }, styles),
            value: stateValue
          }, filteredProps, {
            onChange: this.handleChange,
            ref: this.textAreaRef
          })),
          /*#__PURE__*/
          React__default.createElement("textarea", {
            "aria-hidden": true,
            readOnly: true,
            tabIndex: -1,
            style: _objectSpread2(_objectSpread2({}, shadowStyles), styles),
            ref: this.shadowRef
          }))
        );
      }
    }]);

    return TextAreaComponent;
  }(React.PureComponent);

  TextAreaComponent.defaultProps = {
    customStyles: {}
  };
  var TextArea = withStyles(TextAreaComponent);

  var getStyles$G = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    var autoWidth = arguments.length > 1 ? arguments[1] : undefined;
    return {
      containerStyles: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: autoWidth ? 0 : '30px',
        position: 'relative'
      },
      defaultLabelStyles: {
        color: theme.textField.label,
        fontSize: '18px',
        lineHeight: '24px'
      },
      errorStyles: {
        color: theme.textField.error
      },
      iconContainerStyles: {
        position: 'absolute',
        right: 0,
        top: 0
      },
      iconLabelStyles: {
        cursor: 'pointer'
      }
    };
  };

  var TextFieldComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(TextFieldComponent, _PureComponent);

    var _super = _createSuper(TextFieldComponent);

    function TextFieldComponent() {
      var _this;

      _classCallCheck(this, TextFieldComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.renderLabel = function (_ref) {
        var label = _ref.label,
            props = _objectWithoutProperties(_ref, ["label"]);

        return label ?
        /*#__PURE__*/
        React__default.createElement(Label, props, label) : null;
      };

      _this.renderInput = function (props) {
        return (
          /*#__PURE__*/
          React__default.createElement(Input, props)
        );
      };

      _this.renderTextArea = function (props) {
        return (
          /*#__PURE__*/
          React__default.createElement(TextArea, props)
        );
      };

      return _this;
    }

    _createClass(TextFieldComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            customInputStyles = _this$props.customInputStyles,
            customLabelStyles = _this$props.customLabelStyles,
            customIconStyles = _this$props.customIconStyles,
            iconComponent = _this$props.iconComponent,
            name = _this$props.name,
            label = _this$props.label,
            error = _this$props.error,
            theme = _this$props.theme,
            multiline = _this$props.multiline,
            fullWidth = _this$props.fullWidth,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "customInputStyles", "customLabelStyles", "customIconStyles", "iconComponent", "name", "label", "error", "theme", "multiline", "fullWidth"]);

        var _getStyles = getStyles$G(theme, restProps.autoWidth),
            containerStyles = _getStyles.containerStyles,
            errorStyles = _getStyles.errorStyles,
            iconContainerStyles = _getStyles.iconContainerStyles,
            iconLabelStyles = _getStyles.iconLabelStyles;

        var errorFieldStyles = error ? errorStyles : {};

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        var fieldStyles = _objectSpread2(_objectSpread2({}, customInputStyles), errorFieldStyles);

        var renderField = multiline ? this.renderTextArea : this.renderInput;
        styles.maxWidth = fullWidth ? '100%' : '320px';
        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: styles
          }, this.renderLabel({
            label: label,
            name: name,
            customStyles: customLabelStyles
          }), renderField(_objectSpread2(_objectSpread2({
            name: name
          }, restProps), {}, {
            customStyles: fieldStyles
          })),
          /*#__PURE__*/
          React__default.createElement("div", {
            style: _objectSpread2(_objectSpread2({}, iconContainerStyles), customIconStyles)
          },
          /*#__PURE__*/
          React__default.createElement("label", {
            htmlFor: name,
            style: iconLabelStyles
          }, this.props.iconComponent)))
        );
      }
    }]);

    return TextFieldComponent;
  }(React.PureComponent);

  TextFieldComponent.defaultProps = {
    type: 'text',
    error: false,
    fullWidth: false,
    customInputStyles: {},
    customLabelStyles: {},
    customIconStyles: {}
  };
  var TextField = withStyles(TextFieldComponent);
  var containerStyles$2 = {
    position: 'relative'
  };
  var innerContainerStyles = {
    height: '240px',
    color: '#6E6E7B',
    backgroundColor: '#1B1C23',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  };
  var newLabelStyles = {
    borderTop: "none"
  };
  var customBinStyles = {
    marginLeft: 20,
    minWidth: 20
  };
  var inputStyles = {
    visibility: 'hidden',
    position: 'absolute',
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0
  };

  var getButtonStyles = function getButtonStyles(disabled) {
    return {
      fontSize: 0,
      opacity: disabled ? 0.5 : 1,
      display: 'flex',
      width: 60,
      height: 60,
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: 5
    };
  };

  var getValueStyles = function getValueStyles(disabled, usesNewStyling, hasContent) {
    return {
      fontSize: 18,
      lineHeight: '24px',
      width: usesNewStyling ? hasContent ? 'auto' : '185px' : 'calc(100% - 70px)',
      paddingBottom: 30,
      display: 'flex',
      alignItems: 'center',
      textAlign: usesNewStyling && !hasContent ? 'center' : 'left',
      wordBreak: 'break-word',
      cursor: disabled ? 'cursor' : 'pointer',
      opacity: disabled ? 0.5 : 1
    };
  };

  var getIconWrapperStyles = function getIconWrapperStyles(usesNewStyling) {
    return {
      position: usesNewStyling ? 'relative' : 'absolute',
      right: 0,
      top: 0
    };
  };

  var getLabelStyles = function getLabelStyles(label) {
    return {
      top: label ? 10 : 0,
      position: 'relative'
    };
  };

  var DEFAULT_TEXT_VALUE = 'Select a file';

  var FileUploadComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(FileUploadComponent, _PureComponent);

    var _super = _createSuper(FileUploadComponent);

    function FileUploadComponent() {
      var _this;

      _classCallCheck(this, FileUploadComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        iconComponent: _this.props.iconComponent ||
        /*#__PURE__*/
        React__default.createElement("div", {
          style: _objectSpread2(_objectSpread2({}, getStyles$y(_this.props.theme, BUTTON, _this.props.disabled, BUTTON_SIZES.BIG, _this.props.usesNewStyling).containerStyles), getButtonStyles(_this.props.disabled))
        },
        /*#__PURE__*/
        React__default.createElement(UploadIcon, {
          customStyles: {
            width: 30,
            height: 30
          }
        }))
      };

      _this.iconComponent = function (_ref) {
        var id = _ref.id,
            label = _ref.label;
        return (
          /*#__PURE__*/
          React__default.createElement("label", {
            style: getLabelStyles(label),
            htmlFor: id
          }, _this.state.iconComponent)
        );
      };

      _this.clearInput = function (e) {
        e.preventDefault();

        _this.props.onChange(null);
      };

      _this.renderBin = ifElse(equals(true), always(
      /*#__PURE__*/
      React__default.createElement(BinIcon, {
        customStyles: customBinStyles,
        onClick: _this.clearInput
      })), always(null));

      _this.renderTextField = function (_ref2) {
        var _ref2$fileNames = _ref2.fileNames,
            fileNames = _ref2$fileNames === void 0 ? [] : _ref2$fileNames,
            label = _ref2.label,
            id = _ref2.id,
            customLabelStyles = _ref2.customLabelStyles,
            customInputStyles = _ref2.customInputStyles,
            customIconContainerStyles = _ref2.customIconContainerStyles,
            placeholder = _ref2.placeholder,
            disabled = _ref2.disabled,
            usesNewStyling = _ref2.usesNewStyling;
        var labelStyles = usesNewStyling ? newLabelStyles : {};
        return (
          /*#__PURE__*/
          React__default.createElement(React.Fragment, null,
          /*#__PURE__*/
          React__default.createElement(Label, {
            htmlFor: id,
            customStyles: _objectSpread2(_objectSpread2({}, customLabelStyles), labelStyles)
          }, label),
          /*#__PURE__*/
          React__default.createElement("div", {
            style: usesNewStyling ? innerContainerStyles : {}
          },
          /*#__PURE__*/
          React__default.createElement("label", {
            htmlFor: id,
            style: _objectSpread2(_objectSpread2({}, getValueStyles(disabled, usesNewStyling, fileNames.length)), customInputStyles)
          }, fileNames.length && fileNames || placeholder || DEFAULT_TEXT_VALUE, _this.renderBin(!!fileNames.length && _this.props.isRemovable)),
          /*#__PURE__*/
          React__default.createElement("div", {
            style: _objectSpread2(_objectSpread2({}, getIconWrapperStyles(usesNewStyling)), customIconContainerStyles)
          }, _this.iconComponent({
            id: id,
            label: label,
            disabled: disabled
          }))))
        );
      };

      _this.renderContent = function (data) {
        return data.label ? _this.renderTextField(data) : _this.iconComponent(data);
      };

      return _this;
    }

    _createClass(FileUploadComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            id = _this$props.id,
            fileNames = _this$props.fileNames,
            label = _this$props.label,
            customStyles = _this$props.customStyles,
            customLabelStyles = _this$props.customLabelStyles,
            customInputStyles = _this$props.customInputStyles,
            customIconContainerStyles = _this$props.customIconContainerStyles,
            iconComponent = _this$props.iconComponent,
            multiple = _this$props.multiple,
            placeholder = _this$props.placeholder,
            disabled = _this$props.disabled,
            usesNewStyling = _this$props.usesNewStyling,
            restProps = _objectWithoutProperties(_this$props, ["id", "fileNames", "label", "customStyles", "customLabelStyles", "customInputStyles", "customIconContainerStyles", "iconComponent", "multiple", "placeholder", "disabled", "usesNewStyling"]);

        var filteredProps = filterAllowedAttributes('input', restProps);
        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: _objectSpread2(_objectSpread2({}, containerStyles$2), customStyles)
          }, this.renderContent({
            fileNames: fileNames,
            label: label,
            id: id,
            customStyles: customStyles,
            customLabelStyles: customLabelStyles,
            customInputStyles: customInputStyles,
            customIconContainerStyles: customIconContainerStyles,
            multiple: multiple,
            placeholder: placeholder,
            disabled: disabled,
            usesNewStyling: usesNewStyling
          }),
          /*#__PURE__*/
          React__default.createElement("input", Object.assign({
            style: inputStyles,
            "aria-hidden": true,
            id: id,
            multiple: multiple,
            type: "file",
            disabled: disabled
          }, filteredProps)))
        );
      }
    }]);

    return FileUploadComponent;
  }(React.PureComponent);

  FileUploadComponent.defaultProps = {
    disabled: false,
    isRemovable: false,
    usesNewStyling: false,
    customStyles: {},
    customInputStyles: {},
    customLabelStyles: {}
  };
  var FileUpload = withStyles(FileUploadComponent);

  var getStyles$H = function getStyles(_ref) {
    var _ref$theme = _ref.theme,
        theme = _ref$theme === void 0 ? defaultTheme : _ref$theme,
        reverse = _ref.reverse;
    return {
      containerStyles: {
        display: 'flex',
        flexDirection: reverse ? 'row-reverse' : 'row',
        justifyContent: reverse ? 'flex-end' : 'space-between',
        alignItems: 'center',
        height: 48,
        color: theme.checkbox.text,
        borderBottom: reverse ? 'none' : "1px solid ".concat(theme.checkbox.border)
      },
      iconContainerStyles: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: 0
      },
      inputStyles: {
        visibility: 'hidden',
        position: 'absolute',
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0
      },
      labelStyles: {
        cursor: 'pointer',
        marginRight: reverse ? 10 : 0
      },
      elementStyles: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    };
  };

  var CheckboxGroupContext = React.createContext({});

  var CheckboxComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CheckboxComponent, _PureComponent);

    var _super = _createSuper(CheckboxComponent);

    function CheckboxComponent() {
      var _this;

      _classCallCheck(this, CheckboxComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.renderCheckboxIcon = function (_ref) {
        var checked = _ref.checked,
            checkedIcon = _ref.checkedIcon,
            uncCheckedIcon = _ref.uncCheckedIcon;
        return checked ? checkedIcon : uncCheckedIcon;
      };

      _this.renderEditIcon = function (isEdit) {
        return isEdit ?
        /*#__PURE__*/
        React__default.createElement(EditIcon, null) : null;
      };

      return _this;
    }

    _createClass(CheckboxComponent, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            id = _this$props.id,
            children = _this$props.children,
            isEdit = _this$props.isEdit,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["id", "children", "isEdit", "theme"]);

        return (
          /*#__PURE__*/
          React__default.createElement(CheckboxGroupContext.Consumer, null, function (_ref2) {
            var onChange = _ref2.onChange,
                _ref2$value = _ref2.value,
                value = _ref2$value === void 0 ? [] : _ref2$value,
                name = _ref2.name,
                checkedIcon = _ref2.checkedIcon,
                uncCheckedIcon = _ref2.uncCheckedIcon,
                customCheckboxStyles = _ref2.customCheckboxStyles,
                reverse = _ref2.reverse;
            var checked = value.includes(restProps.value);

            var _getStyles = getStyles$H({
              theme: theme,
              reverse: reverse
            }),
                containerStyles = _getStyles.containerStyles,
                inputStyles = _getStyles.inputStyles,
                iconContainerStyles = _getStyles.iconContainerStyles,
                labelStyles = _getStyles.labelStyles,
                elementStyles = _getStyles.elementStyles;

            var styles = _objectSpread2(_objectSpread2({}, containerStyles), customCheckboxStyles);

            var filteredProps = filterAllowedAttributes('label', restProps);
            return (
              /*#__PURE__*/
              React__default.createElement("div", {
                style: styles
              },
              /*#__PURE__*/
              React__default.createElement("input", Object.assign({
                onChange: onChange,
                value: restProps.value,
                name: name,
                checked: checked,
                "aria-hidden": true,
                type: "checkbox",
                id: id,
                style: inputStyles
              }, filteredProps)),
              /*#__PURE__*/
              React__default.createElement("span", {
                style: elementStyles
              }, children),
              /*#__PURE__*/
              React__default.createElement("div", {
                style: iconContainerStyles
              }, _this2.renderEditIcon(isEdit),
              /*#__PURE__*/
              React__default.createElement("label", {
                style: labelStyles,
                htmlFor: id
              }, _this2.renderCheckboxIcon({
                checked: checked,
                checkedIcon: checkedIcon,
                uncCheckedIcon: uncCheckedIcon
              }))))
            );
          })
        );
      }
    }]);

    return CheckboxComponent;
  }(React.PureComponent);

  var Checkbox = withStyles(CheckboxComponent);

  var getStyles$I = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      display: 'flex',
      flexDirection: 'column',
      borderTop: "1px solid ".concat(theme.checkbox.border)
    };
  };

  var CheckboxGroupComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CheckboxGroupComponent, _PureComponent);

    var _super = _createSuper(CheckboxGroupComponent);

    function CheckboxGroupComponent() {
      _classCallCheck(this, CheckboxGroupComponent);

      return _super.apply(this, arguments);
    }

    _createClass(CheckboxGroupComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            name = _this$props.name,
            children = _this$props.children,
            onChange = _this$props.onChange,
            value = _this$props.value,
            customStyles = _this$props.customStyles,
            isEdit = _this$props.isEdit,
            checkedIcon = _this$props.checkedIcon,
            uncCheckedIcon = _this$props.uncCheckedIcon,
            customCheckboxStyles = _this$props.customCheckboxStyles,
            theme = _this$props.theme,
            reverse = _this$props.reverse,
            restProps = _objectWithoutProperties(_this$props, ["name", "children", "onChange", "value", "customStyles", "isEdit", "checkedIcon", "uncCheckedIcon", "customCheckboxStyles", "theme", "reverse"]);

        var context = {
          name: name,
          onChange: onChange,
          value: value,
          isEdit: isEdit,
          checkedIcon: checkedIcon,
          uncCheckedIcon: uncCheckedIcon,
          customCheckboxStyles: customCheckboxStyles,
          reverse: reverse
        };
        var containerStyles = getStyles$I(theme);

        var styles = _objectSpread2(_objectSpread2({}, containerStyles), customStyles);

        var filteredProps = filterAllowedAttributes('div', restProps);
        return (
          /*#__PURE__*/
          React__default.createElement("div", Object.assign({
            style: styles
          }, filteredProps),
          /*#__PURE__*/
          React__default.createElement(CheckboxGroupContext.Provider, {
            value: context
          }, children))
        );
      }
    }]);

    return CheckboxGroupComponent;
  }(React.PureComponent);

  CheckboxGroupComponent.defaultProps = {
    customStyles: {},
    customCheckboxStyles: {},
    reverse: false,
    checkedIcon:
    /*#__PURE__*/
    React__default.createElement(CheckboxOnIcon, null),
    uncCheckedIcon:
    /*#__PURE__*/
    React__default.createElement(CheckboxOffIcon, null)
  };
  var CheckboxGroup = withStyles(CheckboxGroupComponent);

  var getStyles$J = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      containerStyles: {
        display: 'flex',
        width: '100%',
        color: theme.text
      },
      getSelectStyle: function getSelectStyle() {
        var hidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return {
          display: hidden ? 'none' : 'flex'
        };
      },
      selectWrapperStyles: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        cursor: 'pointer'
      },
      customOptionStyle: function customOptionStyle(index) {
        return {
          cursor: 'pointer',
          padding: '20px 10px',
          border: "1px solid  ".concat(theme.select.border),
          borderTop: !index ? "1px solid  ".concat(theme.select.border) : 'none',
          color: theme.secondaryText,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        };
      },
      selectedOptionsStyles: {
        display: 'flex',
        cursor: 'pointer',
        width: '100%'
      },
      selectedOptionStyles: {
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%'
      },
      optionListStyles: function optionListStyles(menuOpen) {
        return {
          display: menuOpen ? 'block' : 'none',
          maxHeight: '184px',
          overflowY: menuOpen ? 'auto' : 'hidden',
          flexDirection: 'column',
          position: 'absolute',
          width: '100%',
          top: 'calc(100% + 5px)',
          left: '0',
          zIndex: 99,
          backgroundColor: theme.select.background,
          WebkitOverflowScrolling: 'touch'
        };
      },
      hoverStyles: {
        backgroundColor: theme.text,
        color: theme.background
      }
    };
  };

  var SelectComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(SelectComponent, _PureComponent);

    var _super = _createSuper(SelectComponent);

    function SelectComponent() {
      var _this;

      _classCallCheck(this, SelectComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        isMenuOpen: false,
        hoverIndex: null
      };

      _this.setOpenFunction = function (isMenuOpen) {
        return _this.props.setOpen ? _this.props.setOpen(isMenuOpen) : _this.setState({
          isMenuOpen: isMenuOpen
        });
      };

      _this.handleOptionClick = function (_ref) {
        var value = _ref.target.value;

        var selectedOption = _this.props.options.find(function (option) {
          return option.value === value;
        });

        _this.props.onSelect(selectedOption);

        _this.setOpenFunction(false);
      };

      _this.onClickDocument = function () {
        _this.setOpenFunction(false);

        document.removeEventListener('click', _this.onClickDocument);
      };

      _this.toggleMenu = function () {
        var isMenuOpen = !_this.state.isMenuOpen;

        if (isMenuOpen) {
          document.addEventListener('click', _this.onClickDocument);
        }

        _this.setOpenFunction(isMenuOpen);
      };

      _this.renderSelectedOption = function (_ref2, label) {
        var selectedOptionStyles = _ref2.selectedOptionStyles;
        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: selectedOptionStyles
          }, label)
        );
      };

      _this.renderOptions = function (_ref3, index, _ref4) {
        var value = _ref3.value,
            label = _ref3.label,
            selected = _ref3.selected,
            onClick = _ref3.onClick;
        var customOptionStyle = _ref4.customOptionStyle,
            hoverStyles = _ref4.hoverStyles;
        var eventObj = {
          target: {
            value: value
          }
        };
        var actionStyles = selected || index === _this.state.hoverIndex ? hoverStyles : {};
        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            key: index,
            id: "select-item-".concat(index),
            style: _objectSpread2(_objectSpread2({}, customOptionStyle(index)), actionStyles),
            onMouseOver: function onMouseOver() {
              return _this.setState({
                hoverIndex: index
              });
            },
            onMouseOut: function onMouseOut() {
              return _this.setState({
                hoverIndex: null
              });
            },
            onClick: onClick ? onClick : function () {
              return _this.handleOptionClick(eventObj);
            }
          }, label)
        );
      };

      _this.renderNativeOptions = function (_ref5, index) {
        var value = _ref5.value,
            label = _ref5.label,
            selected = _ref5.selected,
            onClick = _ref5.onClick;
        return (
          /*#__PURE__*/
          React__default.createElement("option", {
            key: index,
            value: value,
            onClick: onClick
          }, label)
        );
      };

      _this.renderNativeSelect = function (_ref6, restProps) {
        var _ref6$hidden = _ref6.hidden,
            hidden = _ref6$hidden === void 0 ? false : _ref6$hidden,
            getSelectStyle = _ref6.restStyles.getSelectStyle;
        var options = _this.props.options;
        var onChange = !!hidden ? Function.prototype : _this.handleOptionClick;
        var filteredProps = filterAllowedAttributes('select', restProps);
        return (
          /*#__PURE__*/
          React__default.createElement("select", Object.assign({
            style: getSelectStyle(hidden),
            onChange: onChange
          }, filteredProps), options.map(_this.renderNativeOptions))
        );
      };

      _this.renderCustomSelect = function (_ref7, props) {
        var selectWrapperStyles = _ref7.selectWrapperStyles,
            selectedOptionsStyles = _ref7.selectedOptionsStyles,
            optionListStyles = _ref7.optionListStyles,
            restStyles = _objectWithoutProperties(_ref7, ["selectWrapperStyles", "selectedOptionsStyles", "optionListStyles"]);

        var id = props.id,
            setOpen = props.setOpen,
            customSelectedWrapperStyles = props.customSelectedWrapperStyles;
        var label = pipe(prop('options'), find(function (_ref8) {
          var selected = _ref8.selected;
          return selected;
        }), propOr(_this.props.placeholder, 'label'))(_this.props);
        var isMenuOpen = setOpen ? _this.props.open : !_this.state.isMenuOpen;
        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            id: id,
            style: selectWrapperStyles
          },
          /*#__PURE__*/
          React__default.createElement("div", {
            style: _objectSpread2(_objectSpread2({}, selectedOptionsStyles), customSelectedWrapperStyles),
            onClick: setOpen ? function () {} : _this.toggleMenu
          }, _this.renderSelectedOption(restStyles, label)),
          /*#__PURE__*/
          React__default.createElement("div", {
            style: optionListStyles(isMenuOpen)
          }, _this.props.options.map(function (item, index) {
            return _this.renderOptions(item, index, restStyles);
          })))
        );
      };

      return _this;
    }

    _createClass(SelectComponent, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.setOpen && this.props.open && prevProps.open !== this.props.open) {
          document.addEventListener('click', this.onClickDocument);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            native = _this$props.native,
            theme = _this$props.theme,
            restProps = _objectWithoutProperties(_this$props, ["native", "theme"]);

        var _getStyles = getStyles$J(theme),
            containerStyles = _getStyles.containerStyles,
            restStyles = _objectWithoutProperties(_getStyles, ["containerStyles"]);

        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: containerStyles
          }, native ? this.renderNativeSelect({
            restStyles: restStyles
          }, restProps) : this.renderCustomSelect(restStyles, restProps))
        );
      }
    }]);

    return SelectComponent;
  }(React.PureComponent);

  SelectComponent.defaultProps = {
    native: false,
    placeholder: '',
    setOpen: null,
    open: null,
    customSelectedWrapperStyles: {}
  };
  var Select = withStyles(SelectComponent);

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  var getStyles$K = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      containerStyles: {
        border: "2px dashed ".concat(theme.border),
        width: '100%',
        height: 50,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'copy',
        textAlign: 'center',
        borderRadius: 10,
        lineHeight: '50px'
      },
      hiddenStyles: {
        position: 'absolute',
        top: 5,
        left: 0,
        height: 'calc(100% - 10px)',
        background: theme.background,
        transition: 'opacity 200ms ease-in-out',
        opacity: 0,
        visibility: 'hidden'
      }
    };
  };

  var DEFAULT_LABEL = 'Drop here';

  var DropZoneComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(DropZoneComponent, _PureComponent);

    var _super = _createSuper(DropZoneComponent);

    function DropZoneComponent() {
      var _this;

      _classCallCheck(this, DropZoneComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.counter = 0;
      _this.dropRef = React.createRef();

      _this.hideDropZone = function () {
        if (_this.dropRef.current && _this.props.hidden) {
          _this.dropRef.current.style.visibility = 'hidden';
          _this.dropRef.current.style.opacity = 0;
        }
      };

      _this.showDropZone = function () {
        if (_this.dropRef.current && _this.props.hidden) {
          _this.dropRef.current.style.visibility = 'visible';
          _this.dropRef.current.style.opacity = 0.9;
        }
      };

      _this.handleDragLeave = function () {
        _this.counter--;

        if (_this.counter === 0) {
          _this.hideDropZone();
        }
      };

      _this.handleDragEnter = function (e) {
        _this.counter++;

        if (e.dataTransfer.types.includes('Files')) {
          _this.showDropZone();
        }
      };

      _this.handleDragOver = function (e) {
        e.preventDefault();

        if (_this.dropRef.current.id !== e.target.id) {
          e.dataTransfer.effectAllowed = 'none';
          e.dataTransfer.dropEffect = 'none';
        }
      };

      _this.handleDrop = function (e) {
        e.preventDefault();

        var acceptFiles = _this.getAcceptFiles(e.dataTransfer.files);

        if (!acceptFiles.length) {
          return;
        }

        var files = _this.props.multiple ? acceptFiles : [acceptFiles[0]];

        _this.props.onChange(files);

        _this.hideDropZone();
      };

      _this.getAcceptFiles = function (files) {
        var acceptedTypes = _this.props.accept.replace(/\s/g, '').split(',');

        if (!acceptedTypes[0]) {
          return files;
        }

        return _toConsumableArray(files).filter(function (_ref) {
          var name = _ref.name,
              type = _ref.type;
          return acceptedTypes.includes(type) || acceptedTypes.includes(name.match(/\.[0-9a-z]+$/i)[0]);
        });
      };

      return _this;
    }

    _createClass(DropZoneComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('drop', this.handleDragLeave);
        document.addEventListener('dragover', this.handleDragOver);
        document.addEventListener('dragenter', this.handleDragEnter);
        document.addEventListener('dragleave', this.handleDragLeave);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('drop', this.handleDragLeave);
        document.removeEventListener('dragover', this.handleDragOver);
        document.removeEventListener('dragenter', this.handleDragEnter);
        document.removeEventListener('dragleave', this.handleDragLeave);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            hidden = _this$props.hidden,
            id = _this$props.id,
            theme = _this$props.theme,
            label = _this$props.label,
            customStyles = _this$props.customStyles,
            inputId = _this$props.inputId;
        var styles = getStyles$K(theme);

        var mainStyles = _objectSpread2(_objectSpread2({}, styles.containerStyles), customStyles);

        var containerStyles = hidden ? _objectSpread2(_objectSpread2({}, mainStyles), styles.hiddenStyles) : mainStyles;
        return (
          /*#__PURE__*/
          React__default.createElement("label", {
            style: containerStyles,
            onDrop: this.handleDrop,
            ref: this.dropRef,
            id: id,
            htmlFor: inputId
          }, label)
        );
      }
    }]);

    return DropZoneComponent;
  }(React.PureComponent);

  DropZoneComponent.defaultProps = {
    hidden: false,
    multiple: false,
    accept: '',
    inputId: '',
    id: 'dropZone-schema-ui',
    label: DEFAULT_LABEL,
    customStyles: {}
  };
  var DropZone = withStyles(DropZoneComponent);

  var getStyles$L = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return {
      switchStyles: {
        background: active ? theme.switch.backgroundActive : theme.switch.background,
        width: 44,
        height: 24,
        borderRadius: 20,
        padding: 2,
        transition: 'background 200ms ease-in-out',
        cursor: 'pointer',
        boxSizing: 'border-box'
      },
      circleStyles: {
        background: theme.switch.circle,
        transform: "translateX(".concat(active ? '20px' : '0', ")"),
        width: 20,
        height: 20,
        borderRadius: '50%',
        transition: 'transform 200ms ease-in-out'
      },
      labelStyles: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer'
      },
      inputStyles: {
        visibility: 'hidden',
        position: 'absolute',
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0
      }
    };
  };

  var SwitchComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(SwitchComponent, _PureComponent);

    var _super = _createSuper(SwitchComponent);

    function SwitchComponent() {
      var _this;

      _classCallCheck(this, SwitchComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.renderSwitch = function (_ref) {
        var styles = _ref.styles,
            circleStyles = _ref.circleStyles;
        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: styles
          },
          /*#__PURE__*/
          React__default.createElement("div", {
            style: circleStyles
          }))
        );
      };

      _this.renderSwitchWithoutLabel = function (_ref2) {
        var styles = _ref2.styles,
            id = _ref2.id,
            circleStyles = _ref2.circleStyles;
        return (
          /*#__PURE__*/
          React__default.createElement("label", {
            htmlFor: id
          }, _this.renderSwitch({
            styles: styles,
            circleStyles: circleStyles
          }))
        );
      };

      _this.renderSwitchWithLabel = function (_ref3) {
        var styles = _ref3.styles,
            id = _ref3.id,
            circleStyles = _ref3.circleStyles,
            label = _ref3.label,
            labelStyles = _ref3.labelStyles;
        return (
          /*#__PURE__*/
          React__default.createElement(Label, {
            customStyles: labelStyles,
            name: id
          }, label, _this.renderSwitch({
            styles: styles,
            circleStyles: circleStyles
          }))
        );
      };

      return _this;
    }

    _createClass(SwitchComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            value = _this$props.value,
            label = _this$props.label,
            id = _this$props.id,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme", "value", "label", "id"]);

        var _getStyles = getStyles$L(theme, value),
            switchStyles = _getStyles.switchStyles,
            circleStyles = _getStyles.circleStyles,
            labelStyles = _getStyles.labelStyles,
            inputStyles = _getStyles.inputStyles;

        var styles = _objectSpread2(_objectSpread2({}, switchStyles), customStyles);

        var renderContent = label ? this.renderSwitchWithLabel : this.renderSwitchWithoutLabel;
        var filteredProps = filterAllowedAttributes('input', restProps);
        return (
          /*#__PURE__*/
          React__default.createElement("div", null,
          /*#__PURE__*/
          React__default.createElement("input", Object.assign({
            type: "checkbox",
            id: id,
            checked: value
          }, filteredProps, {
            style: inputStyles
          })), renderContent({
            styles: styles,
            circleStyles: circleStyles,
            label: label,
            labelStyles: labelStyles,
            id: id
          }))
        );
      }
    }]);

    return SwitchComponent;
  }(React.PureComponent);

  SwitchComponent.defaultProps = {
    label: null,
    customStyles: {}
  };
  var Switch = withStyles(SwitchComponent);
  var Form = {
    Input: Input,
    Label: Label,
    RadioGroup: RadioGroup,
    RadioBaseComponent: RadioBaseComponent,
    RadioStyled: RadioStyled,
    TextArea: TextArea,
    TextField: TextField,
    FileUpload: FileUpload,
    Checkbox: Checkbox,
    CheckboxGroup: CheckboxGroup,
    Select: Select,
    DropZone: DropZone,
    Switch: Switch
  };

  var getStyles$M = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      containerStyles: {
        display: 'flex',
        flexDirection: 'row'
      },
      dotStyles: {
        width: '12px',
        height: '12px',
        backgroundColor: theme.stepper.background,
        display: 'block',
        borderRadius: '50%',
        margin: '0 4px',
        cursor: 'pointer'
      },
      dotActiveStyles: {
        backgroundColor: theme.stepper.active,
        cursor: 'default',
        pointerEvents: 'none'
      }
    };
  };

  var StepperComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(StepperComponent, _PureComponent);

    var _super = _createSuper(StepperComponent);

    function StepperComponent() {
      var _this;

      _classCallCheck(this, StepperComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.getActiveStyles = function (_ref) {
        var step = _ref.step,
            activeStep = _ref.activeStep,
            dotActiveStyles = _ref.dotActiveStyles,
            customActiveDotStyles = _ref.customActiveDotStyles;
        return activeStep === step ? _objectSpread2(_objectSpread2({}, dotActiveStyles), customActiveDotStyles) : {};
      };

      _this.renderDots = function (_ref2) {
        var steps = _ref2.steps,
            restProps = _objectWithoutProperties(_ref2, ["steps"]);

        return _toConsumableArray(Array(steps)).map(function (value, key) {
          return _this.renderDot(_objectSpread2({
            key: key
          }, restProps));
        });
      };

      _this.renderDot = function (_ref3) {
        var key = _ref3.key,
            onStepChange = _ref3.onStepChange,
            dotStyles = _ref3.dotStyles,
            customDotStyles = _ref3.customDotStyles,
            restProps = _objectWithoutProperties(_ref3, ["key", "onStepChange", "dotStyles", "customDotStyles"]);

        return (
          /*#__PURE__*/
          React__default.createElement("span", {
            style: _objectSpread2(_objectSpread2(_objectSpread2({}, dotStyles), customDotStyles), _this.getActiveStyles(_objectSpread2({
              step: key + 1
            }, restProps))),
            onClick: function onClick() {
              return onStepChange(key + 1);
            },
            key: key
          })
        );
      };

      _this.render = function () {
        var _this$props = _this.props,
            customStyles = _this$props.customStyles,
            theme = _this$props.theme,
            activeStep = _this$props.activeStep,
            onStepChange = _this$props.onStepChange,
            customActiveDotStyles = _this$props.customActiveDotStyles,
            customDotStyles = _this$props.customDotStyles,
            steps = _this$props.steps,
            restProps = _objectWithoutProperties(_this$props, ["customStyles", "theme", "activeStep", "onStepChange", "customActiveDotStyles", "customDotStyles", "steps"]);

        var _getStyles = getStyles$M(theme),
            containerStyles = _getStyles.containerStyles,
            dotActiveStyles = _getStyles.dotActiveStyles,
            dotStyles = _getStyles.dotStyles;

        var customProps = {
          customStyles: customStyles,
          theme: theme,
          activeStep: activeStep,
          onStepChange: onStepChange,
          customActiveDotStyles: customActiveDotStyles,
          customDotStyles: customDotStyles,
          steps: steps,
          dotActiveStyles: dotActiveStyles,
          dotStyles: dotStyles
        };
        var filteredProps = filterAllowedAttributes('div', restProps);
        return (
          /*#__PURE__*/
          React__default.createElement("div", Object.assign({
            style: _objectSpread2(_objectSpread2({}, containerStyles), customStyles)
          }, filteredProps), _this.renderDots(customProps))
        );
      };

      return _this;
    }

    return StepperComponent;
  }(React.PureComponent);

  StepperComponent.defaultProps = {
    customDotStyles: {},
    onStepChange: function onStepChange() {}
  };
  var Stepper = withStyles(StepperComponent);

  var getStyles$N = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    var _theme$table = theme.table,
        background = _theme$table.background,
        border = _theme$table.border,
        text = _theme$table.text;
    var cell = {
      padding: '7px 12px',
      borderBottom: "2px solid ".concat(border.body),
      borderRight: "2px solid ".concat(border.body),
      maxWidth: '250px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'pre'
    };

    var headerCell = _objectSpread2(_objectSpread2({}, cell), {}, {
      padding: '12px',
      borderRightColor: border.header,
      borderBottomColor: border.header
    });

    var thead = {
      color: text.header,
      backgroundColor: background.header,
      fontWeight: 600
    };

    var headerLeftCell = _objectSpread2(_objectSpread2(_objectSpread2({}, headerCell), thead), {}, {
      textAlign: 'center'
    });

    return {
      tableWrapper: {
        width: '100%',
        overflowX: 'auto',
        paddingBottom: '10px'
      },
      iOSStyles: {
        overflowX: 'scroll',
        WebkitOverflowScrolling: 'touch'
      },
      table: {
        borderCollapse: 'collapse',
        minWidth: '100%',
        fontSize: '14px',
        color: text.body
      },
      thead: thead,
      lastRow: {
        borderBottomColor: border.body,
        paddingBottom: '10px'
      },
      cell: cell,
      cellCustom: _objectSpread2(_objectSpread2({}, cell), {}, {
        border: "2px solid ".concat(border.body)
      }),
      headerCell: headerCell,
      headerFirstCell: _objectSpread2(_objectSpread2({}, headerCell), {}, {
        textAlign: 'center'
      }),
      headerLastCell: _objectSpread2(_objectSpread2({}, headerCell), {}, {
        borderRightColor: border.body
      }),
      headerLeftCell: headerLeftCell,
      headerLastLeftCell: _objectSpread2(_objectSpread2({}, headerLeftCell), {}, {
        borderBottomColor: background.header
      })
    };
  };

  var headerBaseWidth = 40;
  var headerNarrowWidth = 25;

  var isIOS = function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  var NUMBERED_COLUMN_NAME = '#';
  var ROWS_LIMIT = 10;
  var NESTED_VALUE_CHARS_LIMIT = 30;
  var NESTED_VALUE_SUFFIX = '...';

  var TableComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(TableComponent, _PureComponent);

    var _super = _createSuper(TableComponent);

    function TableComponent() {
      var _this;

      _classCallCheck(this, TableComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.getLastIndex = function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return data.length - 1;
      };

      _this.getHeaderCellStyle = function (index, lastIndex, numberedRows, countRows, _ref) {
        var headerCell = _ref.headerCell,
            headerFirstCell = _ref.headerFirstCell,
            headerLastCell = _ref.headerLastCell;

        if (!index && numberedRows) {
          return _objectSpread2(_objectSpread2({}, headerFirstCell), {}, {
            width: countRows < ROWS_LIMIT ? headerNarrowWidth : headerBaseWidth
          });
        }

        if (index === lastIndex) {
          return headerLastCell;
        }

        return headerCell;
      };

      _this.renderHeader = function (styles) {
        return (
          /*#__PURE__*/
          React__default.createElement("thead", {
            style: styles.thead
          },
          /*#__PURE__*/
          React__default.createElement("tr", null, _this.renderHeaderCells(styles)))
        );
      };

      _this.renderNumberedCell = function (index, lastIndex, numberedRows, _ref2) {
        var headerLeftCell = _ref2.headerLeftCell,
            headerLastLeftCell = _ref2.headerLastLeftCell;

        if (!numberedRows) {
          return null;
        }

        var styles = index === lastIndex ? headerLastLeftCell : headerLeftCell;
        return (
          /*#__PURE__*/
          React__default.createElement("td", {
            style: styles
          }, index + 1)
        );
      };

      _this.stringifyNestedValue = function (value) {
        return is(Object, value) ? JSON.stringify(value).substring(0, NESTED_VALUE_CHARS_LIMIT).concat(NESTED_VALUE_SUFFIX) : value;
      };

      _this.renderCells = function (data, cellStyles) {
        return data.map(function (value, index) {
          return (
            /*#__PURE__*/
            React__default.createElement("td", {
              style: cellStyles,
              key: index
            }, "".concat(_this.stringifyNestedValue(value)))
          );
        });
      };

      _this.renderRows = function (styles) {
        var _this$props = _this.props,
            rows = _this$props.rows,
            numberedRows = _this$props.numberedRows;

        var lastIndex = _this.getLastIndex(rows);

        var cellStyles = numberedRows ? styles.cell : styles.cellCustom;
        return rows.map(function (cells, index) {
          return (
            /*#__PURE__*/
            React__default.createElement("tr", {
              key: index
            }, _this.renderNumberedCell(index, lastIndex, numberedRows, styles), _this.renderCells(cells, cellStyles))
          );
        });
      };

      _this.renderTable = function (styles) {
        var header = _this.props.header.length ? _this.renderHeader(styles) : null;
        return (
          /*#__PURE__*/
          React__default.createElement("table", {
            style: styles.table
          }, header,
          /*#__PURE__*/
          React__default.createElement("tbody", null, _this.renderRows(styles)))
        );
      };

      return _this;
    }

    _createClass(TableComponent, [{
      key: "renderHeaderCells",
      value: function renderHeaderCells(styles) {
        var _this2 = this;

        var _this$props2 = this.props,
            header = _this$props2.header,
            numberedRows = _this$props2.numberedRows,
            rows = _this$props2.rows;
        var data = numberedRows ? [NUMBERED_COLUMN_NAME].concat(_toConsumableArray(header)) : header;
        var lastIndex = this.getLastIndex(data);
        var countRows = rows.length;
        return data.map(function (value, index) {
          return (
            /*#__PURE__*/
            React__default.createElement("th", {
              style: _this2.getHeaderCellStyle(index, lastIndex, numberedRows, countRows, styles),
              key: index
            }, "".concat(value))
          );
        });
      }
    }, {
      key: "render",
      value: function render() {
        var theme = this.props.theme;
        var styles = getStyles$N(theme);
        var wrapperStyles = isIOS() ? _objectSpread2(_objectSpread2({}, styles.table), styles.iOSStyles) : styles.tableWrapper;
        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: wrapperStyles
          }, this.renderTable(styles))
        );
      }
    }]);

    return TableComponent;
  }(React.PureComponent);

  TableComponent.defaultProps = {
    numberedRows: false,
    header: []
  };
  var Table = withStyles(TableComponent);

  var ThemeProvider =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ThemeProvider, _PureComponent);

    var _super = _createSuper(ThemeProvider);

    function ThemeProvider() {
      _classCallCheck(this, ThemeProvider);

      return _super.apply(this, arguments);
    }

    _createClass(ThemeProvider, [{
      key: "render",
      value: function render() {
        return (
          /*#__PURE__*/
          React__default.createElement(ThemeContext.Provider, {
            value: {
              theme: this.props.theme
            }
          },
          /*#__PURE__*/
          React__default.createElement("div", {
            style: this.props.theme.providerContainer
          }, this.props.children))
        );
      }
    }]);

    return ThemeProvider;
  }(React.PureComponent);

  ThemeProvider.defaultProps = {
    theme: light
  };

  var getStyles$O = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      containerStyles: {
        display: 'flex',
        padding: '20px 0',
        borderBottom: "1px solid ".concat(theme.breadcrumbs.border)
      },
      separatorStyles: {
        color: theme.breadcrumbs.separator,
        marginLeft: '14px'
      },
      itemStyles: {
        color: theme.breadcrumbs.link,
        display: 'flex',
        marginRight: '14px',
        alignItems: 'flex-end'
      }
    };
  };

  var SEPARATOR_SYMBOL = '>';

  var Breadcrumbs =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Breadcrumbs, _PureComponent);

    var _super = _createSuper(Breadcrumbs);

    function Breadcrumbs() {
      var _this;

      _classCallCheck(this, Breadcrumbs);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.shouldRenderSeparator = function (index, length) {
        return length > 1 && index < length;
      };

      _this.parseStringOr = function (node) {
        return typeof node === 'string' ? "".concat(node) : node;
      };

      _this.renderSeparator = function () {
        var _getStyles = getStyles$O(_this.props.theme),
            separatorStyles = _getStyles.separatorStyles;

        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: separatorStyles
          }, _this.parseStringOr(_this.props.separatorSymbol))
        );
      };

      _this.renderItem = function (item, index) {
        var _getStyles2 = getStyles$O(_this.props.theme),
            itemStyles = _getStyles2.itemStyles;

        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: itemStyles,
            key: index
          }, item, _this.shouldRenderSeparator(index + 1, _this.props.children.length) ? _this.renderSeparator() : null)
        );
      };

      return _this;
    }

    _createClass(Breadcrumbs, [{
      key: "render",
      value: function render() {
        var children = this.props.children;

        var _getStyles3 = getStyles$O(this.props.theme),
            containerStyles = _getStyles3.containerStyles;

        return children.length > 1 ?
        /*#__PURE__*/
        React__default.createElement("div", {
          style: containerStyles
        }, children.map(this.renderItem)) : this.renderItem(children);
      }
    }]);

    return Breadcrumbs;
  }(React.PureComponent);

  Breadcrumbs.defaultProps = {
    separatorSymbol: SEPARATOR_SYMBOL
  };

  var getStyles$P = function getStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTheme;
    return {
      containerStyles: {
        color: theme.link.text,
        textDecoration: 'none'
      }
    };
  };

  var Link =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Link, _PureComponent);

    var _super = _createSuper(Link);

    function Link() {
      _classCallCheck(this, Link);

      return _super.apply(this, arguments);
    }

    _createClass(Link, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            theme = _this$props.theme,
            children = _this$props.children;

        var _getStyles = getStyles$P(theme),
            containerStyles = _getStyles.containerStyles;

        return (
          /*#__PURE__*/
          React__default.createElement("a", Object.assign({}, this.props, {
            style: containerStyles
          }), children)
        );
      }
    }]);

    return Link;
  }(React.PureComponent);

  var getStyles$Q = function getStyles() {
    return {
      containerStyles: {
        backgroundColor: 'transparent',
        display: 'flex',
        flexDirection: 'column'
      }
    };
  };

  var LinkItem =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(LinkItem, _PureComponent);

    var _super = _createSuper(LinkItem);

    function LinkItem() {
      _classCallCheck(this, LinkItem);

      return _super.apply(this, arguments);
    }

    _createClass(LinkItem, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            theme = _this$props.theme,
            render = _this$props.render;

        var _getStyles = getStyles$Q(),
            containerStyles = _getStyles.containerStyles;

        if (render) {
          return render(containerStyles);
        }

        return (
          /*#__PURE__*/
          React__default.createElement(Link, Object.assign({
            style: containerStyles
          }, this.props), children)
        );
      }
    }]);

    return LinkItem;
  }(React.PureComponent);

  exports.Accordion = Accordion;
  exports.AccordionDetails = AccordionDetails;
  exports.AccordionHeader = AccordionHeader;
  exports.AccordionPanel = AccordionPanel;
  exports.BUTTON_SIZES = BUTTON_SIZES;
  exports.Breadcrumbs = Breadcrumbs;
  exports.Button = Button;
  exports.Card = Card;
  exports.Form = Form;
  exports.Header = Header;
  exports.Icons = Icons;
  exports.Link = Link;
  exports.LinkItem = LinkItem;
  exports.Menu = Menu;
  exports.Stepper = Stepper;
  exports.Table = Table;
  exports.Theme = Theme;
  exports.ThemeProvider = ThemeProvider;
  exports.Typography = Typography;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});